import React, { useState,useEffect } from "react";
import {
  Search, ChevronDown, Filter, Plus, X, Phone, MapPin, Truck,
  CheckCircle2, Circle, ChevronRight, ChevronLeft, Edit2, Clock,
  Navigation, Building2, User, Bike, Car, Layers, ClipboardList,
  Package, FlaskConical, Cable, ToggleLeft, Zap, Paintbrush, Droplet,Map,
  Grid3x3, Sparkles, ArrowRight, Check, PackageCheck, Trash2,Route,Edit,CheckCircle,XCircle,Globe,Users,CarFront,Warehouse
} from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../Components/Tabs";
import { Button } from "../../Components/Button";
import { Card } from "../../Components/Card";
import { Badge } from "../../Components/Badge";
import { Input } from "../../Components/Input";
import Pagination, { usePagination } from "../../Components/Pagination";
import { decryptData } from "../../../utils/storageCrypto";


const vehicleTypeIcon = {
  van: "🚐", truck: "🚛", semi: "🚚", bike: "🏍️", container: "🚢",
};


const partnerTypeConfig = {
  "Brickbucket": { label: "Own Fleet", color: "bg-green-100 text-green-700", icon: Truck },
  "3 PL": { label: "3PL", color: "bg-blue-100 text-blue-700", icon: Globe },
  "On Demand": { label: "On Demand", color: "bg-purple-100 text-purple-700", icon: Zap },
  "Supplier": { label: "Supplier", color: "bg-orange-100 text-orange-700", icon: Route },
};

/* ---------------------------------------------------------------------- */
/* Design tokens                                                          */
/* ---------------------------------------------------------------------- */
const ACCENT = "#f7525a";
const ACCENT_SOFT = "#eff6ff";
const SUCCESS = "#16a34a";

const CATEGORY_ICON = {
  "Cement": Package,
  "Construction Chemicals": FlaskConical,
  "Electrical Pipes Fittings & MetalBoxes": Cable,
  "Electrical Switches Switchgear & DB": ToggleLeft,
  "Electrical Wires & Cables": Zap,
  "Paints": Paintbrush,
  "Sanitary Fittings": Droplet,
  "Tile Fixing Products": Grid3x3,
  "Wall Putties & Textures": Layers,
  "Paint Accessories": Sparkles,
};

/* ---------------------------------------------------------------------- */
/* Mock Data                                                              */
/* ---------------------------------------------------------------------- */
const ORDERS = [
  {
    orderNumber: "ORD-88213",
    orderedDate: "05 Sep 2026",
    status: "In Transit",
    eta: "12 Sep, 10:30",
    remaining: "1d 6h",
    partner: { name: "Ramesh Kumar", phone: "+91 98765 43210", vehicle: "Truck Van" },
    pickup: "Auto Nagar Hub, Vijayawada",
    dropoff: "Benz Circle Site, Vijayawada",
    deliveryGroups: [
      {
        dg: "DG-1142",
        status: "In Transit",
        eta: "12 Sep, 10:30",
        remaining: "1d 6h",
        distHub: "4.2 km",
        distCustomer: "18.6 km",
        route: "Via Hub",
        suppliers: "Ultratech Distributors, Dr. Fixit Depot",
        items: [
          { id: "OI-1", po: "PO-22314", name: "OPC 53 Grade Cement 50kg", category: "Cement", qty: 240, weight: "12,000 kg", dimensions: "1.2 x 1.2 x 1.5 m", volume: "2.1 CBM", supplier: "Ultratech Distributors", status: "In Transit", distHub: "4.2 km", distCustomer: "18.6 km" },
          { id: "OI-2", po: "PO-22318", name: "Waterproof Coating Compound 20L", category: "Construction Chemicals", qty: 60, weight: "1,200 kg", dimensions: "0.5 x 0.5 x 0.5 m", volume: "0.12 CBM", supplier: "Dr. Fixit Depot", status: "In Transit", distHub: "6.8 km", distCustomer: "22.1 km" },
        ]
      }
    ]
  },
  {
    orderNumber: "ORD-88247",
    orderedDate: "06 Sep 2026",
    status: "Scheduled",
    eta: "13 Sep, 09:00",
    remaining: "2d 4h",
    partner: { name: "Suresh Babu", phone: "+91 98765 21098", vehicle: "Truck Auto" },
    pickup: "Ring Road DC, Vijayawada",
    dropoff: "Governorpet Site, Vijayawada",
    deliveryGroups: [
      {
        dg: "DG-1144",
        status: "Scheduled",
        eta: "13 Sep, 09:00",
        remaining: "2d 4h",
        distHub: "3.1 km",
        distCustomer: "14.4 km",
        route: "Direct",
        suppliers: "Finolex Regional Hub, Havells Trade Center",
        items: [
          { id: "OI-3", po: "PO-22322", name: "PVC Conduit Pipe 25mm (Bundle)", category: "Electrical Pipes Fittings & MetalBoxes", qty: 150, weight: "450 kg", dimensions: "3.0 x 0.2 x 0.2 m", volume: "0.12 CBM", supplier: "Finolex Regional Hub", status: "Scheduled", distHub: "3.1 km", distCustomer: "14.4 km" },
          { id: "OI-4", po: "PO-22327", name: "MCB Distribution Box 8-Way", category: "Electrical Switches Switchgear & DB", qty: 35, weight: "70 kg", dimensions: "0.4 x 0.3 x 0.2 m", volume: "0.02 CBM", supplier: "Havells Trade Center", status: "Scheduled", distHub: "5.5 km", distCustomer: "9.8 km" },
        ]
      }
    ]
  }
];

const SHIPMENTS = [
  { id: "SH-4471", weight: "1,240 kg", po: "PO-22314", dg: "DG-1142", od: "09 Sep", eta: "12 Sep, 10:30", remaining: "1d 6h", origin: "Auto Nagar Hub", destination: "Benz Circle Site", status: "In Transit", items: [
    { id: "OI-1", name: "OPC 53 Grade Cement 50kg", category: "Cement", qty: 240, weight: "12,000 kg", dimensions: "1.2 x 1.2 x 1.5 m", volume: "2.1 CBM", supplier: "Ultratech Distributors", status: "In Transit" }
  ]},
  { id: "SH-4472", weight: "860 kg", po: "PO-22318", dg: "DG-1143", od: "09 Sep", eta: "12 Sep, 14:00", remaining: "1d 10h", origin: "Gollapudi Warehouse", destination: "Patamata Site", status: "Delivered", items: [
    { id: "OI-2", name: "Waterproof Coating Compound 20L", category: "Construction Chemicals", qty: 60, weight: "1,200 kg", dimensions: "0.5 x 0.5 x 0.5 m", volume: "0.12 CBM", supplier: "Dr. Fixit Depot", status: "Delivered" },
  ]}
];

const TRIPS = [
  { 
    id: "TRP-000054", shipments: 2, legs: "Leg 1 — Direct", eta: "12 Sep, 17:45", remaining: "1d 13h", origin: "Auto Nagar Hub", destination: "Benz Circle Site", status: "In Transit", type: "Direct", orders: 5, distance: "42.6 km", duration: "1h 40m",
    assignedPartner: { name: "Ramesh Kumar", vehicle: "Truck Van" },
    shipmentsList: ["SH-4471", "SH-4472"],
    routeLegs: [
      { title: "Depart Origin", subtext: "Auto Nagar Hub", distance: "0 km", eta: "Completed", done: true },
      { title: "Waypoint 1", subtext: "MG Road Transit", distance: "12.4 km", eta: "12 Sep, 15:30", done: true },
      { title: "Arrive Destination", subtext: "Benz Circle Site", distance: "42.6 km", eta: "12 Sep, 17:45", done: false },
    ]
  },
  { 
    id: "TRP-000055", shipments: 1, legs: "Leg 1–2 — Hub & Spoke", eta: "13 Sep, 09:00", remaining: "2d 4h", origin: "Ring Road DC", destination: "Poranki Site", status: "Scheduled", type: "Hub & Spoke", orders: 3, distance: "58.2 km", duration: "2h 05m",
    assignedPartner: null,
    shipmentsList: ["SH-4472"],
    routeLegs: [
      { title: "Depart Origin", subtext: "Ring Road DC", distance: "0 km", eta: "13 Sep, 07:00", done: false },
      { title: "Arrive Hub", subtext: "Central Hub", distance: "24.0 km", eta: "13 Sep, 08:00", done: false },
      { title: "Arrive Destination", subtext: "Poranki Site", distance: "58.2 km", eta: "13 Sep, 09:00", done: false },
    ]
  },
];

const FLEETS = [
  { name: "Brickbucket", subtitle: "Own Fleet", vehicles: 42, drivers: 38, icon: Truck },
  { name: "3 PL", subtitle: "Third-Party Logistics", vehicles: 27, drivers: 25, icon: Building2 },
];

const PARTNERS = [
  { name: "Ramesh Kumar", vehicleType: "TRUCK VAN", fleetType: "own", phone: "+91 98765 43210", reg: "AP16 TA 4471", email: "ramesh.k@brickbucket.in" },
  { name: "Suresh Babu", vehicleType: "TRUCK AUTO", fleetType: "own", phone: "+91 98765 21098", reg: "AP16 TB 2210", email: "suresh.b@brickbucket.in" },
];

const TABS = [
  { key: "orders", label: "Orders", icon: ClipboardList },
  { key: "shipments", label: "Shipments", icon: Package },
  { key: "trips", label: "Trips", icon: Route },
  { key: "fleet", label: "Fleet & Partners", icon: Truck },
];

/* ---------------------------------------------------------------------- */
/* Shared Components                                                      */
/* ---------------------------------------------------------------------- */
function Th({ children, className = "" }) {
  return <th className={`text-left text-xs font-medium text-slate-500 px-4 py-3 whitespace-nowrap ${className}`}>{children}</th>;
}

function Td({ children, className = "", colSpan, onClick }) {
  return <td colSpan={colSpan} onClick={onClick} className={`px-4 py-3 align-middle text-sm text-slate-700 whitespace-nowrap ${className}`}>{children}</td>;
}

function Pill({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-600",
    blue: "bg-blue-50 text-blue-700",
    green: "bg-green-50 text-green-700",
    amber: "bg-amber-50 text-amber-700",
  };
  return <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium tracking-wide ${tones[tone]}`}>{children}</span>;
}

function TopBar({ placeholder, primaryLabel, onPrimary }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2 flex-1 max-w-full">
        <div className="relative flex-1 max-w-full">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input type="text" placeholder={placeholder} className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-slate-200 bg-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-400" />
        </div>
        <button className="flex items-center gap-1.5 px-3 py-2 text-sm text-slate-600 border border-slate-200 rounded-lg bg-white hover:bg-slate-50"><Filter className="w-3.5 h-3.5" /> Filters</button>
      </div>
      <button onClick={onPrimary} className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white rounded-lg shadow-sm hover:brightness-110" style={{ backgroundColor: ACCENT }}>
        <Plus className="w-4 h-4" /> {primaryLabel}
      </button>
    </div>
  );
}

function LiveTimeline({ steps }) {
  return (
    <div className="pl-1">
      {steps.map((s, i) => (
        <div key={i} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className="w-3.5 h-3.5 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: s.done ? SUCCESS : "#cbd5e1" }}>
              {s.done && <Check className="w-2.5 h-2.5 text-white" strokeWidth={3} />}
            </div>
            {i < steps.length - 1 && <div className="w-px flex-1 min-h-[28px]" style={{ backgroundColor: s.done ? SUCCESS : "#e2e8f0" }} />}
          </div>
          <div className="pb-5 w-full">
            <div className="text-sm font-medium text-slate-800 flex justify-between w-full pr-4">
              <span>{s.title} {s.done && <span className="text-xs font-normal text-green-600">— Completed</span>}</span>
              {s.eta && <span className="text-xs text-blue-600 font-medium whitespace-nowrap ml-2">ETA: {s.eta}</span>}
            </div>
            <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1">
              <MapPin className="w-3 h-3" /> {s.subtext}
              {s.distance && <span className="ml-2 px-1.5 py-0.5 bg-slate-100 rounded text-[10px] text-slate-600">Dist: {s.distance || 0}</span>}
            </div>
            {s.shipments && (
              <div className="mt-1.5 text-xs text-slate-500">
                <span className="font-medium text-slate-600">Shipments Dropping Off:</span> {s.shipments.join(", ")}
              </div>
            )}
            {/* Renders custom actions like OTP inputs inside the timeline loop */}
            {s.actionNode && (
              <div className="mt-2.5">
                {s.actionNode}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Tracking & Detail Popups                                               */
/* ---------------------------------------------------------------------- */

/* function OrderTrackPanel({ order, onClose }) {

  useEffect(() => {
    //fetchOrderTracking();
  }, []);

  const fetchOrderTracking = async (orderId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-order-tracking?order_id=${orderId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in fetchOrderTracking:", error);
      throw error;
    }
  };

  if (!order) return null;
  const orderShipments = SHIPMENTS.filter(s => s.po && order.deliveryGroups.some(dg => dg.items.some(i => i.po === s.po)));

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white h-full shadow-xl border-l border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div>
            <div className="text-sm font-semibold text-slate-800">Order Tracking</div>
            <div className="text-xs text-slate-500 mt-0.5">{order.orderNumber}</div>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="px-6 py-5 overflow-y-auto flex-1">
          <div className="grid grid-cols-2 gap-3 mb-5 border border-slate-200 p-3 rounded-lg bg-slate-50">
             <div>
                <div className="text-xs text-slate-500">Overall Order ETA</div>
                <div className="text-sm font-semibold text-blue-700">{order.eta}</div>
             </div>
             <div>
                <div className="text-xs text-slate-500">Time Remaining</div>
                <div className="text-sm font-semibold text-slate-700">{order.remaining}</div>
             </div>
          </div>

          <div className="text-xs font-medium text-slate-500 mb-3">Overall Progress</div>
          <LiveTimeline steps={[
            { title: "Order Confirmed", subtext: order.orderedDate, done: true },
            { title: "In Transit", subtext: "En Route to site", done: order.status === "Delivered" },
            { title: "Delivered", subtext: order.dropoff, done: order.status === "Delivered" },
          ]} />
          
          <div className="mt-6">
             <div className="text-xs font-medium text-slate-500 mb-3 border-b border-slate-200 pb-2">Delivery Groups ({order.deliveryGroups.length})</div>
             {order.deliveryGroups.map(dg => (
               <div key={dg.dg} className="mb-3 border border-slate-200 rounded-lg p-3">
                 <div className="flex justify-between items-center mb-1">
                   <span className="text-sm font-semibold">{dg.dg}</span>
                   <Pill tone={dg.status === "Delivered" ? "green" : "blue"}>{dg.status}</Pill>
                 </div>
                  <div className="text-xs text-slate-500">
                    ETA: {new Date(dg.eta).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>
                 </div>
             ))}
          </div>

          <div className="mt-4">
             <div className="text-xs font-medium text-slate-500 mb-3 border-b border-slate-200 pb-2">Associated Shipments ({orderShipments.length})</div>
             {orderShipments.map(s => (
               <div key={s.id} className="mb-3 border border-slate-200 rounded-lg p-3">
                 <div className="flex justify-between items-center mb-1">
                   <span className="font-medium text-sm text-slate-800">{s.id}</span>
                   <span className="text-xs text-slate-500">{s.eta}</span>
                 </div>
                 <div className="text-xs text-slate-500">{s.origin} ➔ {s.destination}</div>
               </div>
             ))}
          </div>
        </div>
      </div>
    </div>
  );
} */

function OrderTrackPanel({ order, shipments: propShipments, onClose }) {
  const [activeTab, setActiveTab] = useState("all"); // "all" | "dgs" | "pos" | "shipments" | "items"
  const [expandedDGs, setExpandedDGs] = useState(new Set());
  const [expandedShipments, setExpandedShipments] = useState(new Set());
  const [apiTrackingData, setApiTrackingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (order) {
      console.log(order)
      // Auto-expand all DGs by default for easy scanning
      setExpandedDGs(new Set((order.deliveryGroups || []).map(dg => dg.dg)));
      
      const targetId = order.orderId || order._id || order.id || order.orderNumber;
      if (targetId) {
        fetchOrderTracking(targetId);
      }
    }
  }, [order]);

  const fetchOrderTracking = async (orderId) => {
    try {
      setIsLoading(true);
      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-order-tracking?order_id=${orderId}`,
        {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': token || ""
          }
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        console.log("fetchOrderTracking:",result);
        if (result.success && result.data) {
          setApiTrackingData(result.data);
        }
      }
    } catch (error) {
      console.warn("Using fallback local order tracking data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!order) return null;

  // Toggle helpers
  const toggleDG = (dgId) => {
    setExpandedDGs(prev => {
      const next = new Set(prev);
      if (next.has(dgId)) next.delete(dgId);
      else next.add(dgId);
      return next;
    });
  };

  const toggleShipment = (sId) => {
    setExpandedShipments(prev => {
      const next = new Set(prev);
      if (next.has(sId)) next.delete(sId);
      else next.add(sId);
      return next;
    });
  };

  // 1. Resolve Associated Shipments
  const availableShipments = propShipments && propShipments.length > 0 ? propShipments : SHIPMENTS;
  const orderShipments = availableShipments.filter(s => {
    const matchesOrder = s.po === order.orderNumber || s.so_number === order.orderNumber;
    const matchesDG = order.deliveryGroups?.some(dg => 
      s.dg === dg.dg || 
      (Array.isArray(s.dg_ids) && s.dg_ids.includes(dg.dg_id || dg.dg)) ||
      dg.items?.some(i => i.po === s.po || i.po === s.po_number)
    );
    return matchesOrder || matchesDG;
  });

  // 2. Flatten All Items
  const allItems = order.deliveryGroups?.flatMap(dg => 
    dg.items?.map(item => ({
      ...item,
      dgNumber: dg.dg,
      dgStatus: dg.status,
      dgEta: new Date(dg.eta).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            })
    })) || []
  ) || [];

  // 3. Group Items by Purchase Order (PO)
  const poGroups = allItems.reduce((acc, item) => {
    const poKey = item.po || "PO-UNASSIGNED";
    if (!acc[poKey]) {
      acc[poKey] = {
        poNumber: poKey,
        poId: item.po_id,
        supplier: item.supplier,
        dgNumber: item.dgNumber,
        status: item.status,
        items: []
      };
    }
    acc[poKey].items.push(item);
    return acc;
  }, {});
  const poList = Object.values(poGroups);

  // Status mapping helper for Timeline checkmarks
  const isDelivered = order.status?.toLowerCase() === "delivered";
  const isInTransit = order.status?.toLowerCase() === "in transit" || isDelivered;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity" onClick={onClose} />

      {/* Drawer Panel */}
      <div className="relative w-full max-w-2xl bg-white h-full shadow-2xl border-l border-slate-200 flex flex-col z-10 animate-in slide-in-from-right duration-300">
        
        {/* Top Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center text-[#f7525a]">
              <ClipboardList className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-base font-bold text-slate-800">{order.orderNumber}</h3>
                <Pill tone={isDelivered ? "green" : isInTransit ? "blue" : "amber"}>{order.status}</Pill>
              </div>
              <p className="text-xs text-slate-500 mt-0.5">
                Ordered on {new Date(order.orderedDate).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            })} • Site: {order.dropoff}
              </p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="flex items-center gap-2 px-6 pt-3 pb-2 border-b border-slate-200 bg-slate-50 overflow-x-auto">
          {[
            { key: "all", label: "Overview & All", count: null },
            { key: "dgs", label: "Delivery Groups", count: order.deliveryGroups?.length || 0 },
            { key: "pos", label: "Purchase Orders", count: poList.length },
            { key: "shipments", label: "Shipments", count: orderShipments.length },
            { key: "items", label: "Items", count: allItems.length },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                activeTab === tab.key 
                  ? "bg-white text-slate-800 shadow-xs border border-slate-200 font-semibold" 
                  : "text-slate-500 hover:text-slate-700 hover:bg-slate-100"
              }`}
            >
              {tab.label}
              {tab.count !== null && (
                <span className={`text-[10px] px-1.5 py-0.2 rounded-full ${
                  activeTab === tab.key ? "bg-slate-100 text-slate-700" : "bg-slate-200/70 text-slate-500"
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Scrollable Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1 space-y-6">

          {/* 1. OVERALL ORDER METRICS & PROGRESS (Shown on 'all' or default) */}
          {(activeTab === "all") && (
            <>
              {/* Order Quick Specs */}
              <div className="grid grid-cols-4 gap-3">
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Order ETA</div>
                  <div className="text-xs font-bold text-blue-700 mt-1 truncate">{new Date(order.eta).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            })}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Time Remaining</div>
                  <div className="text-xs font-bold text-amber-700 mt-1">{order.remaining || "N/A"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Pickup Origin</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1 truncate" title={order.pickup}>{order.pickup}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Assigned Driver</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1 truncate">{order.partner?.name || "Unassigned"}</div>
                </div>
              </div>

              {/* Order Master Milestone Timeline */}
              <div className="border border-slate-200 rounded-xl p-4 bg-white shadow-xs">
                <div className="flex items-center justify-between mb-4 border-b border-slate-100 pb-2">
                  <span className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                    <Route className="w-4 h-4 text-slate-500" /> Overall Order Milestones
                  </span>
                  <span className="text-xs text-slate-400">Step {isDelivered ? "4 of 4" : isInTransit ? "3 of 4" : "2 of 4"}</span>
                </div>
                <LiveTimeline steps={[
                  { 
                    title: "Order Placed & Confirmed", 
                    subtext: `Order reference ${order.orderNumber} booked on ${order.orderedDate}`, 
                    done: true 
                  },
                  { 
                    title: "Delivery Grouping & PO Generation", 
                    subtext: `${order.deliveryGroups?.length || 0} DGs created across ${poList.length} Purchase Orders`, 
                    done: true 
                  },
                  { 
                    title: "Dispatched / In-Transit", 
                    subtext: isInTransit ? `En route to ${order.dropoff}` : "Awaiting dispatch from suppliers/hub", 
                    eta: new Date(order.eta).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            }),
                    done: isInTransit 
                  },
                  { 
                    title: "Final Site Delivery", 
                    subtext: `Drop off destination: ${order.dropoff}`, 
                    done: isDelivered 
                  },
                ]} />
              </div>
            </>
          )}

          {/* 2. DELIVERY GROUPS (DGs) TRACKING */}
          {(activeTab === "all" || activeTab === "dgs") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <Layers className="w-4 h-4 text-blue-600" /> Delivery Groups ({order.deliveryGroups?.length || 0})
                </div>
                <span className="text-xs text-slate-400">Click to expand/collapse details</span>
              </div>

              <div className="space-y-3">
                {order.deliveryGroups?.map((dg) => {
                  const isOpen = expandedDGs.has(dg.dg);
                  const dgDelivered = dg.status?.toLowerCase() === "delivered";
                  const dgInTransit = dg.status?.toLowerCase() === "in transit" || dgDelivered;

                  return (
                    <div key={dg.dg} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-xs">
                      {/* DG Header */}
                      <div 
                        onClick={() => toggleDG(dg.dg)}
                        className="p-3.5 bg-slate-50 hover:bg-slate-100/80 cursor-pointer flex items-center justify-between border-b border-slate-200 transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <ChevronRight className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? "rotate-90" : ""}`} />
                          <div>
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-bold text-slate-800">{dg.dg}</span>
                              <Pill tone={dgDelivered ? "green" : dgInTransit ? "blue" : "amber"}>{dg.status}</Pill>
                              <span className="text-[11px] px-2 py-0.5 rounded bg-slate-200 text-slate-700 font-medium">
                                {dg.route || "Via Hub"}
                              </span>
                            </div>
                            <div className="text-xs text-slate-500 mt-0.5">
                              Suppliers: <span className="text-slate-700">{dg.suppliers || "Multiple Suppliers"}</span>
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-xs font-semibold text-blue-600">ETA: {new Date(dg.eta).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            })}</div>
                          <div className="text-[11px] text-slate-400">{dg.items?.length || 0} line items</div>
                        </div>
                      </div>

                      {/* DG Expanded Details */}
                      {isOpen && (
                        <div className="p-4 space-y-4">
                          {/* Distance & Route Breakdown */}
                          <div className="grid grid-cols-3 gap-2 bg-slate-50 p-2.5 rounded-lg border border-slate-100 text-xs">
                            <div>
                              <span className="text-slate-400 block text-[10px] uppercase">Hub Distance</span>
                              <span className="font-semibold text-slate-700">{dg.distHub || 0}</span>
                            </div>
                            <div>
                              <span className="text-slate-400 block text-[10px] uppercase">Site Distance</span>
                              <span className="font-semibold text-slate-700">{dg.distCustomer || 0}</span>
                            </div>
                            <div>
                              <span className="text-slate-400 block text-[10px] uppercase">Routing Mode</span>
                              <span className="font-semibold text-blue-700">{dg.route || "Via Hub"}</span>
                            </div>
                          </div>

                          {/* DG Specific Milestones */}
                          <div className="pt-1">
                            <div className="text-[11px] font-bold text-slate-500 uppercase mb-2">DG Progress Milestones</div>
                            <LiveTimeline steps={[
                              { 
                                title: "Supplier Sourcing & Dispatch", 
                                subtext: dg.suppliers, 
                                done: true 
                              },
                              { 
                                title: dg.route === "Direct" ? "Transit Direct to Site" : "Hub Transit & Consolidation", 
                                subtext: dg.route === "Direct" ? `${dg.distCustomer} direct to site` : `${dg.distHub} transit to Hub`, 
                                done: dgInTransit 
                              },
                              { 
                                title: "Site Handover & Unloading", 
                                subtext: `${dg.distCustomer} to destination site`, 
                                done: dgDelivered 
                              },
                            ]} />
                          </div>

                          {/* Items nested under this DG */}
                          <div className="pt-2 border-t border-slate-100">
                            <div className="text-[11px] font-bold text-slate-500 uppercase mb-2">
                              Items in this Delivery Group ({dg.items?.length || 0})
                            </div>
                            <div className="space-y-1.5 max-h-48 overflow-y-auto pr-1">
                              {dg.items?.map((item, idx) => (
                                <div key={idx} className="flex items-center justify-between p-2 rounded-lg bg-slate-50 border border-slate-100 text-xs">
                                  <div className="flex items-center gap-2">
                                    <Package className="w-3.5 h-3.5 text-slate-400" />
                                    <div>
                                      <span className="font-medium text-slate-800">{item.name}</span>
                                      <span className="text-[10px] text-slate-400 block">PO: {item.po} • Qty: {item.qty}</span>
                                    </div>
                                  </div>
                                  <Pill tone={item.status === "Delivered" ? "green" : "slate"}>{item.status || "In Transit"}</Pill>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* 3. PURCHASE ORDERS (POs) TRACKING */}
          {(activeTab === "all" || activeTab === "pos") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <ClipboardList className="w-4 h-4 text-purple-600" /> Purchase Orders ({poList.length})
                </div>
                <span className="text-xs text-slate-400">Grouped by vendor purchase orders</span>
              </div>

              <div className="space-y-2.5">
                {poList.map((po) => (
                  <div key={po.poNumber} className="border border-slate-200 rounded-xl p-3.5 bg-white shadow-xs">
                    <div className="flex justify-between items-center mb-2">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-slate-800 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">
                          {po.poNumber}
                        </span>
                        <span className="text-xs font-medium text-slate-600">{po.supplier || "Vendor"}</span>
                      </div>
                      <Pill tone={po.status === "Delivered" ? "green" : "blue"}>{po.status || "Dispatched"}</Pill>
                    </div>

                    <div className="text-xs text-slate-500 mb-2">
                      Associated DG: <span className="font-semibold text-slate-700">{po.dgNumber}</span> • Contains {po.items.length} item(s)
                    </div>

                    <div className="bg-slate-50 rounded-lg p-2 border border-slate-100 space-y-1">
                      {po.items.map((item, idx) => (
                        <div key={idx} className="flex justify-between items-center text-xs text-slate-700">
                          <span className="truncate max-w-[280px]">• {item.name}</span>
                          <span className="font-medium text-slate-500">{item.qty} {item.UOM || "units"}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 4. SHIPMENTS TRACKING */}
          {(activeTab === "all" || activeTab === "shipments") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <PackageCheck className="w-4 h-4 text-green-600" /> Shipments Linked ({orderShipments.length})
                </div>
                <span className="text-xs text-slate-400">Carrier packages and transit legs</span>
              </div>

              {orderShipments.length === 0 ? (
                <div className="p-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400 text-xs">
                  No direct shipments created yet for this order. Shipments can be generated from the Shipments tab.
                </div>
              ) : (
                <div className="space-y-3">
                  {orderShipments.map((s) => {
                    const isShipOpen = expandedShipments.has(s.id);
                    const sDelivered = s.status?.toLowerCase() === "delivered";

                    return (
                      <div key={s.id} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-xs">
                        <div 
                          onClick={() => toggleShipment(s.id)}
                          className="p-3 bg-slate-50 hover:bg-slate-100 cursor-pointer flex items-center justify-between border-b border-slate-100 transition-colors"
                        >
                          <div className="flex items-center gap-2.5">
                            <ChevronRight className={`w-3.5 h-3.5 text-slate-400 transition-transform ${isShipOpen ? "rotate-90" : ""}`} />
                            <div>
                              <div className="flex items-center gap-2">
                                <span className="font-bold text-xs text-slate-800">{s.shipment_number || s.id}</span>
                                <Pill tone={sDelivered ? "green" : "blue"}>{s.status}</Pill>
                              </div>
                              <div className="text-[11px] text-slate-500 mt-0.5">
                                {s.origin} ➔ {s.destination}
                              </div>
                            </div>
                          </div>
                          <div className="text-right text-xs">
                            <span className="text-slate-400 block text-[10px]">ETA</span>
                            <span className="font-semibold text-blue-600">{s.eta || "Scheduled"}</span>
                          </div>
                        </div>

                        {isShipOpen && (
                          <div className="p-4 space-y-3">
                            <div className="grid grid-cols-3 gap-2 bg-slate-50 p-2 rounded-lg border border-slate-100 text-xs">
                              <div>
                                <span className="text-slate-400 block text-[10px]">Total Weight</span>
                                <span className="font-semibold text-slate-700">{s.weight || "N/A"}</span>
                              </div>
                              <div>
                                <span className="text-slate-400 block text-[10px]">Associated DG</span>
                                <span className="font-semibold text-slate-700">{s.dg || "N/A"}</span>
                              </div>
                              <div>
                                <span className="text-slate-400 block text-[10px]">Remaining</span>
                                <span className="font-semibold text-amber-700">{s.remaining || "N/A"}</span>
                              </div>
                            </div>

                            {/* Shipment Milestones */}
                            <div className="pt-2">
                              <div className="text-[11px] font-bold text-slate-500 uppercase mb-2">Transit Milestones</div>
                              <LiveTimeline steps={[
                                { title: "Origin Hub Dispatch", subtext: s.origin, done: true },
                                { title: "In-Transit Checkpoint", subtext: "Weighbridge / Regional Corridor", done: s.status === "In Transit" || sDelivered },
                                { title: "Delivered to Destination", subtext: s.destination, done: sDelivered },
                              ]} />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* 5. ITEMIZED TRACKING */}
          {(activeTab === "all" || activeTab === "items") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <Package className="w-4 h-4 text-amber-600" /> Line Items Tracking ({allItems.length})
                </div>
                <span className="text-xs text-slate-400">Step progression by item</span>
              </div>

              <div className="space-y-2">
                {allItems.map((item, idx) => {
                  const itemDelivered = item.status?.toLowerCase() === "delivered" || isDelivered;
                  return (
                    <div key={idx} className="border border-slate-200 rounded-xl p-3 bg-white hover:bg-slate-50/50 transition-colors shadow-xs">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3">
                          <div className="w-10 h-10 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden mt-0.5">
                            {item.image ? (
                              <img src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`} alt={item.name} className="w-full h-full object-cover" />
                            ) : (
                              <Package className="w-5 h-5 text-slate-400" />
                            )}
                          </div>
                          <div>
                            <div className="font-semibold text-xs text-slate-800 leading-snug">{item.name}</div>
                            <div className="flex flex-wrap items-center gap-2 mt-1 text-[11px] text-slate-500">
                              <span>PO: <strong className="text-slate-700">{item.po}</strong></span>
                              <span>•</span>
                              <span>DG: <strong className="text-slate-700">{item.dgNumber}</strong></span>
                              <span>•</span>
                              <span>Qty: <strong className="text-slate-700">{item.qty} {item.UOM || ""}</strong></span>
                            </div>
                            <div className="text-[10px] text-slate-400 mt-0.5">
                              Supplier: {item.supplier}
                            </div>
                          </div>
                        </div>

                        <div className="text-right shrink-0">
                          <Pill tone={itemDelivered ? "green" : "blue"}>{item.status || "In Transit"}</Pill>
                          <span className="text-[10px] text-slate-400 block mt-1">
                            {itemDelivered ? "Delivered" : "In Progress"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

        </div>

        {/* Drawer Footer */}
        <div className="px-6 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-xs text-slate-500">
          <div>
            Showing complete tracking hierarchy for <strong className="text-slate-700">{order.orderNumber}</strong>
          </div>
          <button 
            onClick={onClose} 
            className="px-4 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 font-medium hover:bg-slate-100 transition-colors"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}  

/* function DgTrackPanel({ dg, orderInfo, onClose }) {

  useEffect(() => {
    //fetchDGTracking();
  }, []);

  const fetchDGTracking = async (dgId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-dg-tracking?dg_id=${dgId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in fetchDGTracking:", error);
      throw error;
    }
  };

  if (!dg) return null;
  const dgShipments = SHIPMENTS.filter(s => s.dg === dg.dg);

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white h-full shadow-xl border-l border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div>
            <div className="text-sm font-semibold text-slate-800">DG Tracking</div>
            <div className="text-xs text-slate-500 mt-0.5">{dg.dg} • {orderInfo?.orderNumber}</div>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="px-6 py-5 overflow-y-auto flex-1">
          <div className="grid grid-cols-2 gap-3 mb-5 border border-slate-200 p-3 rounded-lg bg-slate-50">
             <div>
                <div className="text-xs text-slate-500">Overall DG ETA</div>
                <div className="text-sm font-semibold text-blue-700">{dg.eta}</div>
             </div>
             <div>
                <div className="text-xs text-slate-500">Time Remaining</div>
                <div className="text-sm font-semibold text-slate-700">{dg.remaining}</div>
             </div>
          </div>

          <div className="text-xs font-medium text-slate-500 mb-3">DG Milestones</div>
          <LiveTimeline steps={[
            { title: "Supplier Dispatch", subtext: dg.suppliers, done: true },
            { title: "Hub Arrival / Transit", subtext: `${dg.distHub} to hub`, done: true },
            { title: "Destination Arrival", subtext: `${dg.distCustomer} to site`, done: dg.status === "Delivered" },
          ]} />

          <div className="mt-6">
             <div className="text-xs font-medium text-slate-500 mb-3 border-b border-slate-200 pb-2">Purchase Orders (POs)</div>
             {dg.items.map(item => (
               <div key={item.id} className="mb-2 p-2 bg-slate-50 border border-slate-100 rounded flex justify-between items-center">
                 <div>
                   <div className="text-sm font-mono text-slate-700">{item.po}</div>
                   <div className="text-xs text-slate-500 truncate w-48">{item.name}</div>
                 </div>
                 <Pill tone="slate">{item.status}</Pill>
               </div>
             ))}
          </div>

          <div className="mt-4">
             <div className="text-xs font-medium text-slate-500 mb-3 border-b border-slate-200 pb-2">Shipments in DG</div>
             {dgShipments.length === 0 ? <div className="text-xs text-slate-400">No shipments found.</div> : 
               dgShipments.map(s => (
                 <div key={s.id} className="mb-2 border border-slate-200 rounded p-3">
                   <div className="flex justify-between items-center mb-1">
                     <span className="font-medium text-sm text-slate-800">{s.id}</span>
                     <Pill tone="blue">{s.status}</Pill>
                   </div>
                   <div className="text-xs text-slate-500">{s.origin} ➔ {s.destination}</div>
                 </div>
               ))
             }
          </div>
        </div>
      </div>
    </div>
  );
} */

function DgTrackPanel({ dg, orderInfo, shipments: propShipments, onClose }) {
  const [activeTab, setActiveTab] = useState("overview"); // "overview" | "pos" | "shipments" | "items"
  const [expandedShipments, setExpandedShipments] = useState(new Set());
  const [apiTrackingData, setApiTrackingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dg) {
      const dgId = dg.dg_id || dg.dg;
      if (dgId) {
        fetchDGTracking(dgId);
      }
    }
  }, [dg]);

  const fetchDGTracking = async (dgId) => {
    try {
      setIsLoading(true);
      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-dg-tracking?dg_id=${dgId}`,
        {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': token || ""
          }
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data) {
          setApiTrackingData(result.data);
        }
      }
    } catch (error) {
      console.warn("Using fallback local DG tracking data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!dg) return null;

  const toggleShipment = (sId) => {
    setExpandedShipments(prev => {
      const next = new Set(prev);
      if (next.has(sId)) next.delete(sId);
      else next.add(sId);
      return next;
    });
  };

  // 1. Resolve Associated Shipments for this specific DG
  const availableShipments = propShipments && propShipments.length > 0 ? propShipments : SHIPMENTS;
  const dgShipments = availableShipments.filter(s => 
    s.dg === dg.dg || 
    (Array.isArray(s.dg_ids) && s.dg_ids.includes(dg.dg_id || dg.dg)) ||
    (dg.items && dg.items.some(i => i.po === s.po || i.po === s.po_number))
  );

  // 2. Map All Items
  const allItems = dg.items || [];

  // 3. Group Items by Purchase Order (PO)
  const poGroups = allItems.reduce((acc, item) => {
    const poKey = item.po || "PO-UNASSIGNED";
    if (!acc[poKey]) {
      acc[poKey] = {
        poNumber: poKey,
        supplier: item.supplier,
        status: item.status,
        items: []
      };
    }
    acc[poKey].items.push(item);
    return acc;
  }, {});
  const poList = Object.values(poGroups);

  // Status mapping helpers
  const isDelivered = dg.status?.toLowerCase() === "delivered";
  const isInTransit = dg.status?.toLowerCase() === "in transit" || isDelivered;
  const isDirect = dg.route === "Direct";

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity" onClick={onClose} />

      {/* Drawer Panel */}
      <div className="relative w-full max-w-2xl bg-white h-full shadow-2xl border-l border-slate-200 flex flex-col z-10 animate-in slide-in-from-right duration-300">
        
        {/* Top Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600">
              <Layers className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-base font-bold text-slate-800">{dg.dg}</h3>
                <Pill tone={isDelivered ? "green" : isInTransit ? "blue" : "amber"}>{dg.status}</Pill>
              </div>
              <p className="text-xs text-slate-500 mt-0.5">
                Order: <span className="font-semibold">{orderInfo?.orderNumber || "N/A"}</span> • {dg.route || "Via Hub"}
              </p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="flex items-center gap-2 px-6 pt-3 pb-2 border-b border-slate-200 bg-slate-50 overflow-x-auto">
          {[
            { key: "overview", label: "DG Overview", count: null },
            { key: "pos", label: "Purchase Orders", count: poList.length },
            { key: "shipments", label: "Shipments", count: dgShipments.length },
            { key: "items", label: "Items", count: allItems.length },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                activeTab === tab.key 
                  ? "bg-white text-slate-800 shadow-xs border border-slate-200 font-semibold" 
                  : "text-slate-500 hover:text-slate-700 hover:bg-slate-100"
              }`}
            >
              {tab.label}
              {tab.count !== null && (
                <span className={`text-[10px] px-1.5 py-0.2 rounded-full ${
                  activeTab === tab.key ? "bg-slate-100 text-slate-700" : "bg-slate-200/70 text-slate-500"
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Scrollable Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1 space-y-6">

          {/* 1. DG OVERVIEW */}
          {(activeTab === "overview") && (
            <>
              {/* Quick Specs */}
              <div className="grid grid-cols-4 gap-3">
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Overall DG ETA</div>
                <div className="text-xs font-bold text-blue-700 mt-1 whitespace-normal break-words leading-tight">
                  {new Date(dg.eta).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Time Remaining</div>
                  <div className="text-xs font-bold text-amber-700 mt-1">{dg.remaining || "N/A"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Dist. to Hub</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1">{dg.distHub || "N/A"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Dist. to Site</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1">{dg.distCustomer || "N/A"}</div>
                </div>
              </div>

              {/* DG Progress Timeline */}
              <div className="border border-slate-200 rounded-xl p-4 bg-white shadow-xs">
                <div className="flex items-center justify-between mb-4 border-b border-slate-100 pb-2">
                  <span className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                    <Route className="w-4 h-4 text-slate-500" /> Delivery Group Milestones
                  </span>
                  <span className="text-[11px] font-medium text-slate-400 bg-slate-100 px-2 py-0.5 rounded">
                    Routing: {dg.route || "Via Hub"}
                  </span>
                </div>
                <LiveTimeline steps={[
                  { 
                    title: "Supplier Sourcing & Dispatch", 
                    subtext: dg.suppliers || "Multiple Suppliers", 
                    done: true 
                  },
                  { 
                    title: isDirect ? "Direct Transit to Site" : "Hub Arrival & Consolidation", 
                    subtext: isDirect ? `${dg.distCustomer} direct to site` : `${dg.distHub} transit to Hub`, 
                    done: isInTransit 
                  },
                  { 
                    title: "Destination Arrival & Handover", 
                    subtext: `${dg.distCustomer} to destination site`, 
                    done: isDelivered 
                  },
                ]} />
              </div>
            </>
          )}

          {/* 2. PURCHASE ORDERS (POs) TRACKING */}
          {(activeTab === "pos") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <ClipboardList className="w-4 h-4 text-purple-600" /> Purchase Orders in {dg.dg} ({poList.length})
                </div>
              </div>

              <div className="space-y-3">
                {poList.length === 0 ? (
                   <div className="text-xs text-slate-400 text-center py-4">No Purchase Orders found.</div>
                ) : (
                  poList.map((po) => (
                    <div key={po.poNumber} className="border border-slate-200 rounded-xl p-3.5 bg-white shadow-xs">
                      <div className="flex justify-between items-center mb-2">
                        <div className="flex items-center gap-2">
                          <span className=" text-xs font-bold text-slate-800 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">
                            {po.poNumber}
                          </span>
                          <span className="text-xs font-medium text-slate-600">{po.supplier || "Supplier"}</span>
                        </div>
                        {/* <Pill tone={po.status === "Delivered" ? "green" : "blue"}>{po.status || "Dispatched"}</Pill> */}
                      </div>

                      <div className="bg-slate-50 rounded-lg p-2 border border-slate-100 space-y-1">
                        {po.items.map((item, idx) => (
                          <div key={idx} className="flex justify-between items-center text-xs text-slate-700">
                            <span className="truncate max-w-[280px] font-medium">• {item.name}</span>
                            <span className="font-medium text-slate-500">{item.qty} {item.UOM || "units"}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* 3. SHIPMENTS TRACKING */}
          {(activeTab === "shipments") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <PackageCheck className="w-4 h-4 text-green-600" /> Shipments for {dg.dg} ({dgShipments.length})
                </div>
              </div>

              {dgShipments.length === 0 ? (
                <div className="p-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400 text-xs">
                  No shipments mapped to this Delivery Group yet.
                </div>
              ) : (
                <div className="space-y-3">
                  {dgShipments.map((s) => {
                    const isShipOpen = expandedShipments.has(s.id);
                    const sDelivered = s.status?.toLowerCase() === "delivered";

                    return (
                      <div key={s.id} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-xs">
                        <div 
                          onClick={() => toggleShipment(s.id)}
                          className="p-3 bg-slate-50 hover:bg-slate-100 cursor-pointer flex items-center justify-between border-b border-slate-100 transition-colors"
                        >
                          <div className="flex items-center gap-2.5">
                            <ChevronRight className={`w-3.5 h-3.5 text-slate-400 transition-transform ${isShipOpen ? "rotate-90" : ""}`} />
                            <div>
                              <div className="flex items-center gap-2">
                                <span className="font-bold text-xs text-slate-800">{s.shipment_number || s.id}</span>
                                <Pill tone={sDelivered ? "green" : "blue"}>{s.status}</Pill>
                              </div>
                              <div className="text-[11px] text-slate-500 mt-0.5">
                                {s.origin} ➔ {s.destination}
                              </div>
                            </div>
                          </div>
                          <div className="text-right text-xs">
                            <span className="text-slate-400 block text-[10px]">ETA</span>
                            <span className="font-semibold text-blue-600">{s.eta || "Scheduled"}</span>
                          </div>
                        </div>

                        {isShipOpen && (
                          <div className="p-4 space-y-3">
                            <div className="grid grid-cols-2 gap-2 bg-slate-50 p-2 rounded-lg border border-slate-100 text-xs">
                              <div>
                                <span className="text-slate-400 block text-[10px]">Total Weight</span>
                                <span className="font-semibold text-slate-700">{s.weight || "N/A"}</span>
                              </div>
                              <div>
                                <span className="text-slate-400 block text-[10px]">Remaining</span>
                                <span className="font-semibold text-amber-700">{s.remaining || "N/A"}</span>
                              </div>
                            </div>

                            {/* Shipment Milestones */}
                            <div className="pt-2">
                              <div className="text-[11px] font-bold text-slate-500 uppercase mb-2">Transit Milestones</div>
                              <LiveTimeline steps={[
                                { title: "Origin Dispatch", subtext: s.origin, done: true },
                                { title: "In-Transit Checkpoint", subtext: "Regional Route / Weighbridge", done: s.status === "In Transit" || sDelivered },
                                { title: "Destination Arrival", subtext: s.destination, done: sDelivered },
                              ]} />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* 4. ITEMIZED TRACKING */}
          {(activeTab === "items") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <Package className="w-4 h-4 text-amber-600" /> Line Items in {dg.dg} ({allItems.length})
                </div>
              </div>

              <div className="space-y-2">
                {allItems.map((item, idx) => {
                  const itemDelivered = item.status?.toLowerCase() === "delivered" || isDelivered;
                  return (
                    <div key={idx} className="border border-slate-200 rounded-xl p-3 bg-white hover:bg-slate-50/50 transition-colors shadow-xs">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3">
                          <div className="w-10 h-10 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden mt-0.5">
                            {item.image ? (
                              <img src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`} alt={item.name} className="w-full h-full object-cover" />
                            ) : (
                              <Package className="w-5 h-5 text-slate-400" />
                            )}
                          </div>
                          <div>
                            <div className="font-semibold text-xs text-slate-800 leading-snug">{item.name}</div>
                            <div className="flex flex-wrap items-center gap-2 mt-1 text-[11px] text-slate-500">
                              <span>PO: <strong className="text-slate-700">{item.po}</strong></span>
                              <span>•</span>
                              <span>Qty: <strong className="text-slate-700">{item.qty} {item.UOM || ""}</strong></span>
                              {item.weight && (
                                <>
                                  <span>•</span>
                                  <span>Wt: <strong className="text-slate-700">
                                    {typeof item.weight === 'object' ? `${item.weight.value} ${item.weight.unit}` : item.weight}
                                  </strong></span>
                                </>
                              )}
                            </div>
                            <div className="text-[10px] text-slate-400 mt-0.5">
                              Supplier: {item.supplier}
                            </div>
                          </div>
                        </div>

                        <div className="text-right shrink-0">
{/*                           <Pill tone={itemDelivered ? "green" : "blue"}>{item.status || "In Transit"}</Pill>*/}
                          <span className="text-[10px] text-slate-400 block mt-1">
                            {itemDelivered ? "Delivered" : "In Progress"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

        </div>

        {/* Drawer Footer */}
        <div className="px-6 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-xs text-slate-500">
          <div>
            Viewing specific details for Delivery Group <strong className="text-slate-700">{dg.dg}</strong>
          </div>
          <button 
            onClick={onClose} 
            className="px-4 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 font-medium hover:bg-slate-100 transition-colors"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}

/* function ShipmentTrackPanel({ shipment, onClose }) {

  useEffect(() => {
    //fetchShipmentTracking();
  }, []);

  const fetchShipmentTracking = async (shipmentId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-shipment-tracking?shipment_id=${shipmentId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in fetchShipmentTracking:", error);
      throw error;
    }
  };

  if (!shipment) return null;

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white h-full shadow-xl border-l border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div>
            <div className="text-sm font-semibold text-slate-800">Shipment Tracking</div>
            <div className="text-xs text-slate-500 mt-0.5">{shipment.id}</div>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="px-6 py-5 overflow-y-auto flex-1">
          <div className="flex items-center justify-between text-xs text-slate-500 mb-5 border border-slate-200 rounded-lg px-3 py-2 bg-slate-50">
            <span>{shipment.origin}</span>
            <ArrowRight className="w-3.5 h-3.5 text-slate-400" />
            <span>{shipment.destination}</span>
          </div>
          <div className="text-xs font-medium text-slate-500 mb-3">Transit Milestones</div>
          <LiveTimeline steps={[
              { title: "Origin Warehouse Dispatch", subtext: shipment.origin, done: true },
              { title: "In-Transit Checkpoint", subtext: "Ring Road Weighbridge", done: true },
              { title: "Destination Warehouse Arrival", subtext: shipment.destination, done: shipment.status === 'Delivered' },
          ]} />
        </div>
      </div>
    </div>
  );
} */

function ShipmentTrackPanel({ shipment, onClose }) {
  const [activeTab, setActiveTab] = useState("overview"); // "overview" | "pos" | "items"
  const [apiTrackingData, setApiTrackingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (shipment) {
      const shipmentId = shipment._id || shipment.id;
      if (shipmentId) {
        fetchShipmentTracking(shipmentId);
      }
    }
  }, [shipment]);

  const fetchShipmentTracking = async (shipmentId) => {
    try {
      setIsLoading(true);
      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-shipment-tracking?id=${shipmentId}`,
        {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': token || ""
          }
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data) {
          setApiTrackingData(result.data);
        }
      }
    } catch (error) {
      console.warn("Using fallback local shipment tracking data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!shipment) return null;

  // 1. Map All Items
  const allItems = shipment.items || [];

  // 2. Group Items by Purchase Order (PO)
  const poGroups = allItems.reduce((acc, item) => {
    const poKey = item.po || item.po_number || shipment.po || "PO-UNASSIGNED";
    if (!acc[poKey]) {
      acc[poKey] = {
        poNumber: poKey,
        supplier: item.supplier || shipment.origin?.name || shipment.origin,
        status: item.status || shipment.status,
        items: []
      };
    }
    acc[poKey].items.push(item);
    return acc;
  }, {});
  const poList = Object.values(poGroups);

  // Status mapping helpers
  const isDelivered = shipment.status?.toLowerCase() === "delivered";
  const isInTransit = shipment.status?.toLowerCase() === "in transit" || isDelivered;

  const displayOrigin = typeof shipment.origin === 'object' ? shipment.origin?.name || shipment.origin?.address : shipment.origin;
  const displayDest = typeof shipment.destination === 'object' ? shipment.destination?.name || shipment.destination?.address : shipment.destination;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity" onClick={onClose} />

      {/* Drawer Panel */}
      <div className="relative w-full max-w-2xl bg-white h-full shadow-2xl border-l border-slate-200 flex flex-col z-10 animate-in slide-in-from-right duration-300">
        
        {/* Top Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-green-50 flex items-center justify-center text-green-600">
              <PackageCheck className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-base font-bold text-slate-800">{shipment.shipment_number || shipment.id}</h3>
                <Pill tone={isDelivered ? "green" : isInTransit ? "blue" : "amber"}>{shipment.status}</Pill>
              </div>
              <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-1.5">
                <span className="truncate max-w-[150px]" title={displayOrigin}>{displayOrigin}</span>
                <ArrowRight className="w-3 h-3 text-slate-400" />
                <span className="truncate max-w-[150px]" title={displayDest}>{displayDest}</span>
              </p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="flex items-center gap-2 px-6 pt-3 pb-2 border-b border-slate-200 bg-slate-50 overflow-x-auto">
          {[
            { key: "overview", label: "Shipment Overview", count: null },
            { key: "pos", label: "Purchase Orders", count: poList.length },
            { key: "items", label: "Items", count: allItems.length },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                activeTab === tab.key 
                  ? "bg-white text-slate-800 shadow-xs border border-slate-200 font-semibold" 
                  : "text-slate-500 hover:text-slate-700 hover:bg-slate-100"
              }`}
            >
              {tab.label}
              {tab.count !== null && (
                <span className={`text-[10px] px-1.5 py-0.2 rounded-full ${
                  activeTab === tab.key ? "bg-slate-100 text-slate-700" : "bg-slate-200/70 text-slate-500"
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Scrollable Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1 space-y-6">

          {/* 1. SHIPMENT OVERVIEW */}
          {(activeTab === "overview") && (
            <>
              {/* Quick Specs */}
              <div className="grid grid-cols-4 gap-3">
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">ETA</div>
                  <div className="text-xs font-bold text-blue-700 mt-1 truncate">{shipment.eta || "Pending"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Time Remaining</div>
                  <div className="text-xs font-bold text-amber-700 mt-1">{shipment.remaining || "N/A"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Total Weight</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1">{shipment.weight || "N/A"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Assigned DG</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1 truncate">{shipment.dg || "N/A"}</div>
                </div>
              </div>

              {/* Shipment Progress Timeline */}
              <div className="border border-slate-200 rounded-xl p-4 bg-white shadow-xs">
                <div className="flex items-center justify-between mb-4 border-b border-slate-100 pb-2">
                  <span className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                    <Route className="w-4 h-4 text-slate-500" /> Transit Milestones
                  </span>
                </div>
                
                {apiTrackingData && apiTrackingData.route_progress?.length > 0 ? (
                  /* Live API tracking rendering if available */
                  <LiveTimeline steps={apiTrackingData.route_progress.map(stop => ({
                    title: `Stop: ${stop.stop_type}`,
                    subtext: stop.location || "Pending Location",
                    done: stop.status === "COMPLETED"
                  }))} />
                ) : (
                  /* Fallback timeline */
                  <LiveTimeline steps={[
                    { 
                      title: "Origin Dispatch", 
                      subtext: displayOrigin || "Warehouse", 
                      done: true 
                    },
                    { 
                      title: "In-Transit Checkpoint", 
                      subtext: "En route via regional corridor / Hub", 
                      done: isInTransit 
                    },
                    { 
                      title: "Destination Arrival", 
                      subtext: displayDest || "Site", 
                      done: isDelivered 
                    },
                  ]} />
                )}
              </div>
            </>
          )}

          {/* 2. PURCHASE ORDERS (POs) TRACKING */}
          {(activeTab === "pos") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <ClipboardList className="w-4 h-4 text-purple-600" /> Purchase Orders in Shipment ({poList.length})
                </div>
              </div>

              <div className="space-y-3">
                {poList.length === 0 ? (
                   <div className="text-xs text-slate-400 text-center py-4">No Purchase Orders found.</div>
                ) : (
                  poList.map((po) => (
                    <div key={po.poNumber} className="border border-slate-200 rounded-xl p-3.5 bg-white shadow-xs">
                      <div className="flex justify-between items-center mb-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-bold text-slate-800 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">
                            {po.poNumber}
                          </span>
                          <span className="text-xs font-medium text-slate-600">{po.supplier || "Supplier"}</span>
                        </div>
                        <Pill tone={po.status === "Delivered" ? "green" : "blue"}>{po.status || "In Transit"}</Pill>
                      </div>

                      <div className="bg-slate-50 rounded-lg p-2 border border-slate-100 space-y-1">
                        {po.items.map((item, idx) => (
                          <div key={idx} className="flex justify-between items-center text-xs text-slate-700">
                            <span className="truncate max-w-[280px] font-medium">• {item.name || item.itemName}</span>
                            <span className="font-medium text-slate-500">{item.qty || item.quantity} {item.UOM || "units"}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* 3. ITEMIZED TRACKING */}
          {(activeTab === "items") && (
            <div>
              <div className="flex items-center justify-between mb-3 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <Package className="w-4 h-4 text-amber-600" /> Line Items in Shipment ({allItems.length})
                </div>
              </div>

              {allItems.length === 0 ? (
                <div className="p-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400 text-xs">
                  No line items attached to this shipment yet.
                </div>
              ) : (
                <div className="space-y-2">
                  {allItems.map((item, idx) => {
                    const itemDelivered = (item.status || shipment.status)?.toLowerCase() === "delivered" || isDelivered;
                    return (
                      <div key={idx} className="border border-slate-200 rounded-xl p-3 bg-white hover:bg-slate-50/50 transition-colors shadow-xs">
                        <div className="flex items-start justify-between gap-3">
                          <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden mt-0.5">
                              {item.image || item.itemImage ? (
                                <img src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image || item.itemImage}`} alt={item.name || item.itemName} className="w-full h-full object-cover" />
                              ) : (
                                <Package className="w-5 h-5 text-slate-400" />
                              )}
                            </div>
                            <div>
                              <div className="font-semibold text-xs text-slate-800 leading-snug">{item.name || item.itemName}</div>
                              <div className="flex flex-wrap items-center gap-2 mt-1 text-[11px] text-slate-500">
                                <span>PO: <strong className="text-slate-700">{item.po || item.po_number || shipment.po || "N/A"}</strong></span>
                                <span>•</span>
                                <span>Qty: <strong className="text-slate-700">{item.qty || item.quantity} {item.UOM || ""}</strong></span>
                                {(item.weight || item.itemWeight) && (
                                  <>
                                    <span>•</span>
                                    <span>Wt: <strong className="text-slate-700">
                                      {typeof item.weight === 'object' && item.weight.value 
                                        ? `${item.weight.value} ${item.weight.unit}` 
                                        : (item.weight || `${item.itemWeight} kg`)}
                                    </strong></span>
                                  </>
                                )}
                              </div>
                              <div className="text-[10px] text-slate-400 mt-0.5">
                                Category: {item.category || "N/A"}
                              </div>
                            </div>
                          </div>

                          <div className="text-right shrink-0">
                            <Pill tone={itemDelivered ? "green" : "blue"}>{item.status || shipment.status}</Pill>
                            <span className="text-[10px] text-slate-400 block mt-1">
                              {itemDelivered ? "Delivered" : "In Progress"}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

        </div>

        {/* Drawer Footer */}
        <div className="px-6 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-xs text-slate-500">
          <div>
            Viewing details for Shipment <strong className="text-slate-700">{shipment.shipment_number || shipment.id}</strong>
          </div>
          <button 
            onClick={onClose} 
            className="px-4 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 font-medium hover:bg-slate-100 transition-colors"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}  

/* function TripShipmentsModal({ trip, onClose }) {
  console.log("TripShipmentsModal trip:",trip);
  if (!trip) return null;
  const associatedShipments = SHIPMENTS.filter(s => trip.shipmentsList.includes(s.id));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Trip Shipments: {trip.id}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6 max-h-96 overflow-y-auto">
          {associatedShipments.map(s => (
            <div key={s.id} className="mb-4 border border-slate-200 rounded-lg p-4 bg-slate-50">
               <div className="flex justify-between items-center mb-2">
                 <span className="font-semibold text-slate-800">{s.id}</span>
                 <Pill tone="blue">{s.status}</Pill>
               </div>
               <div className="text-xs text-slate-500 mb-2">Weight: {s.weight} | ETA: {s.eta}</div>
               <div className="text-sm font-medium text-slate-700 flex items-center gap-2">
                 {s.origin} <ArrowRight className="w-3 h-3 text-slate-400" /> {s.destination}
               </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} */

function TripShipmentsModal({ trip, onClose }) {
  if (!trip) return null;
  // Dynamically extract populated shipments from MongoDB route_legs
  const associatedShipments = trip.route_legs?.flatMap(leg => leg.shipments || []) || [];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Trip Shipments: {trip.trip_number}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6 max-h-96 overflow-y-auto">
          {associatedShipments.length === 0 ? (
            <div className="text-sm text-slate-500">No shipments attached to this trip.</div>
          ) : (
            associatedShipments.map(s => (
              <div key={s._id} className="mb-4 border border-slate-200 rounded-lg p-4 bg-slate-50">
                 <div className="flex justify-between items-center mb-2">
                   <span className="font-semibold text-slate-800">SO: {s.so_number || s._id}</span>
                   <Pill tone="blue">{s.status}</Pill>
                 </div>
                 <div className="text-xs text-slate-500 mb-2">Weight: {s.weight || 'N/A'} kg</div>
                 <div className="text-sm font-medium text-slate-700 flex items-center gap-2">
                   {s.origin?.name || 'Origin'} <ArrowRight className="w-3 h-3 text-slate-400" /> {s.destination?.name || 'Destination'}
                 </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}  

/* function TripRouteLegsModal({ trip, onClose }) {
  console.log("TripRouteLegsModal trip:",trip);
  if (!trip) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Trip Route Legs: {trip.id}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto">
          <LiveTimeline steps={trip.routeLegs} />
        </div>
      </div>
    </div>
  );
} */

function TripRouteLegsModal({ trip, onClose }) {
  const [otps, setOtps] = useState({});

  if (!trip) return null;

  const isManual3PL = trip.status === "3pl_assigned" || (trip.platform && !["brickbucket", "own"].includes(trip.platform.toLowerCase()));

  const handleOtpChange = (stopId, val) => {
    setOtps(prev => ({ ...prev, [stopId]: val }));
  };

  const handleVerifyOtp = (stopId, stopType) => {
    console.log(`Verifying ${stopType} OTP for stop ${stopId}:`, otps[stopId]);
    alert(`${stopType} OTP verification triggered: ${otps[stopId]}`);
  };

  // Flatten nested DB stops into timeline steps
  /*   const steps = trip.route_legs?.flatMap(leg => 
      leg.stops?.map(stop => ({
        title: `Stop ${stop.stopSequence}: ${stop.stopType}`,
        subtext: stop.location?.address || "Location pending",
        distance: leg.distance ? `${leg.distance} km (Leg total)` : "",
        eta: stop.plannedTime ? new Date(stop.plannedTime).toLocaleString() : "TBD",
        done: stop.status === 'COMPLETED'
      })) || []
    ) || []; */

  // Flatten nested DB stops into timeline steps with inline OTP logic
  const steps = trip.route_legs?.flatMap(leg => 
    leg.stops?.map((stop, idx) => {
      const stopId = stop._id || `${leg._id || 'leg'}-stop-${idx}`;
      const isPickup = stop.stopType === 'PICKUP';
      const isDropoff = stop.stopType === 'DROPOFF';
      
      // Conditionally show OTP UI inside the timeline line item
      const showOtp = isManual3PL && stop.status !== 'COMPLETED' && (isPickup || isDropoff);

      return {
        title: `Stop ${stop.stopSequence || idx + 1}: ${stop.stopType || 'Waypoint'}`,
        subtext: stop.location?.address || "Location pending",
        distance: leg.distance ? `${leg.distance} km (Leg total)` : 0,
        eta: stop.plannedTime ? new Date(stop.plannedTime).toLocaleString() : "TBD",
        done: stop.status === 'COMPLETED',
        actionNode: showOtp ? (
           <div className="flex gap-2 max-w-sm mt-1.5 p-2 bg-slate-50 rounded-lg border border-slate-200">
              <input 
                type="text" 
                placeholder={`Enter ${isPickup ? 'Pickup' : 'Drop-off'} OTP`} 
                value={otps[stopId] || ""} 
                onChange={(e) => handleOtpChange(stopId, e.target.value)}
                className="w-full text-xs rounded border border-slate-300 px-2 py-1.5 outline-none focus:border-blue-500 bg-white"
              />
              <button onClick={() => handleVerifyOtp(stopId, stop.stopType)} className="px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 whitespace-nowrap transition-colors">
                Verify
              </button>
           </div>
        ) : null
      };
    }) || []
  ) || [];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Trip Route Legs: {trip.trip_number}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto">
          {steps.length > 0 ? <LiveTimeline steps={steps} /> : <div className="text-sm text-slate-500">No routing stops generated yet.</div>}
        </div>
      </div>
    </div>
  );
}

/* function TripTrackModal({ trip, onClose }) {

  useEffect(() => {
    //fetchTripTracking();
  }, []);

  const fetchTripTracking = async (tripId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-trip-tracking?trip_id=${tripId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in fetchTripTracking:", error);
      throw error;
    }
  };

  const [accordionOpen, setAccordionOpen] = useState(true);
  if (!trip) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold">{trip.id}</span>
            <Pill tone="blue">{trip.status}</Pill>
            <Pill tone="slate">{trip.type}</Pill>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>

        <div className="px-6 py-5">
          <div className="grid grid-cols-4 gap-3 mb-5">
            {[
              { label: "Shipments", value: trip.shipments },
              { label: "Est. Total Distance", value: trip.distance },
              { label: "Est. Duration", value: trip.duration },
              { label: "Trip ETA", value: trip.eta },
            ].map((m) => (
              <div key={m.label} className="border border-slate-200 rounded-lg p-3">
                <div className="text-[11px] text-slate-400 mb-1">{m.label}</div>
                <div className="text-sm font-semibold text-slate-800">{m.value}</div>
              </div>
            ))}
          </div>

          <div className="mb-5">
             <div className="text-xs font-medium text-slate-500 mb-2">Shipments in Trip</div>
             <div className="flex gap-2 flex-wrap">
               {trip.shipmentsList?.map(s => (
                  <span key={s} className="px-3 py-1 bg-slate-100 border border-slate-200 rounded text-sm text-slate-700 font-medium flex items-center gap-2">
                     <PackageCheck className="w-3.5 h-3.5 text-slate-500" /> {s}
                  </span>
               ))}
             </div>
          </div>

          <div className="border border-slate-200 rounded-lg overflow-hidden">
            <button onClick={() => setAccordionOpen(!accordionOpen)} className="w-full flex items-center justify-between px-4 py-3 bg-slate-50 text-sm font-medium text-slate-700">
              Route Legs & ETA Tracking
              <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${accordionOpen ? "rotate-180" : ""}`} />
            </button>
            {accordionOpen && (
              <div className="px-4 py-5">
                <div className="text-sm font-medium text-slate-700 mb-4">{trip.legs}</div>
                <LiveTimeline steps={trip.routeLegs} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
} */

/* function TripTrackModal({ trip, onClose }) {
  const [accordionOpen, setAccordionOpen] = useState(true);

  useEffect(() => {
    // fetchTripTracking();
  }, []);

  const fetchTripTracking = async (tripId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-trip-tracking?trip_id=${tripId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in fetchTripTracking:", error);
      throw error;
    }
  };

  if (!trip) return null;

  // 1. Extract database fields safely
  const totalShipments = trip.route_legs?.reduce((acc, leg) => acc + (leg.shipments?.length || 0), 0) || 0;
  const displayDistance = trip.totalDistance ? `${trip.totalDistance} km` : "N/A";
  const displayDuration = trip.totalEstimatedMinutes ? `${trip.totalEstimatedMinutes} mins` : "N/A";

  // 2. Extract nested shipment IDs/Numbers
  const shipmentsInTrip = trip.route_legs?.flatMap(leg => 
    leg.shipments?.map(s => s.so_number || (typeof s === 'string' ? s : s._id)) || []
  ) || [];

  // 3. Map nested route_legs stops to timeline steps for LiveTimeline
  const steps = trip.route_legs?.flatMap(leg => 
    leg.stops?.map(stop => ({
      title: `Stop ${stop.stopSequence || ''}: ${stop.stopType || 'Waypoint'}`,
      subtext: stop.location?.address || "Location pending",
      distance: leg.distance ? `${leg.distance} km (Leg total)` : "",
      eta: stop.plannedTime ? new Date(stop.plannedTime).toLocaleString() : "TBD",
      done: stop.status === 'COMPLETED'
    })) || []
  ) || [];

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold">{trip.trip_number || trip.id}</span>
            <Pill tone="blue">{trip.status}</Pill>
            {trip.type && <Pill tone="slate">{trip.type}</Pill>}
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>

        <div className="px-6 py-5">
          <div className="grid grid-cols-4 gap-3 mb-5">
            {[
              { label: "Shipments", value: totalShipments },
              { label: "Total Distance", value: displayDistance },
              { label: "Trip Duration", value: displayDuration },
              { label: "Trip ETA", value: trip.estimated_delivery_time || trip.eta || 'N/A' },
            ].map((m) => (
              <div key={m.label} className="border border-slate-200 rounded-lg p-3">
                <div className="text-[11px] text-slate-400 mb-1">{m.label}</div>
                <div className="text-sm font-semibold text-slate-800">{m.value}</div>
              </div>
            ))}
          </div>

          <div className="mb-5">
             <div className="text-xs font-medium text-slate-500 mb-2">Shipments in Trip</div>
             <div className="flex gap-2 flex-wrap">
               {shipmentsInTrip.length > 0 ? (
                 shipmentsInTrip.map((s, idx) => (
                   <span key={idx} className="px-3 py-1 bg-slate-100 border border-slate-200 rounded text-sm text-slate-700 font-medium flex items-center gap-2">
                      <PackageCheck className="w-3.5 h-3.5 text-slate-500" /> {s}
                   </span>
                 ))
               ) : (
                 <span className="text-xs text-slate-400">No shipments linked</span>
               )}
             </div>
          </div>

          <div className="border border-slate-200 rounded-lg overflow-hidden">
            <button onClick={() => setAccordionOpen(!accordionOpen)} className="w-full flex items-center justify-between px-4 py-3 bg-slate-50 text-sm font-medium text-slate-700">
              Route Legs & ETA Tracking
              <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${accordionOpen ? "rotate-180" : ""}`} />
            </button>
            {accordionOpen && (
              <div className="px-4 py-5">
                <div className="text-sm font-medium text-slate-700 mb-4">{trip.route_legs?.length || 0} Legs</div>
                {steps.length > 0 ? (
                  <LiveTimeline steps={steps} />
                ) : (
                  <div className="text-sm text-slate-500">No routing stops generated yet.</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}   */

function TripTrackModal({ trip, onClose }) {
  const [activeTab, setActiveTab] = useState("overview"); // "overview" | "route" | "shipments"
  const [apiTrackingData, setApiTrackingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // State for holding per-stop OTP values
  const [otps, setOtps] = useState({});

  useEffect(() => {
    if (trip) {
      const tripId = trip._id || trip.id;
      if (tripId) {
        fetchTripTracking(tripId);
      }
    }
  }, [trip]);

  const fetchTripTracking = async (tripId) => {
    try {
      setIsLoading(true);
      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-trip-tracking?trip_id=${tripId}`,
        {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': token || ""
          }
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data) {
          setApiTrackingData(result.data);
        }
      }
    } catch (error) {
      console.warn("Using fallback local trip tracking data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!trip) return null;

  // 1. Data Extraction & Formatting
  const totalShipments = trip.route_legs?.reduce((acc, leg) => acc + (leg.shipments?.length || 0), 0) || 0;
  const displayDistance = trip.totalDistance ? `${trip.totalDistance} km` : 0;
  const displayDuration = trip.totalEstimatedMinutes ? `${trip.totalEstimatedMinutes} mins` : "N/A";
  
  const tripDelivered = trip.status?.toLowerCase() === "delivered";
  const tripInTransit = trip.status?.toLowerCase() === "in_transit" || trip.status?.toLowerCase() === "dispatched" || tripDelivered;

  // Aggregate all unique shipments across all legs using a plain object to avoid 'new Map()' collision with the lucide-react Map icon
  const uniqueShipmentsObj = {};
  trip.route_legs?.forEach(leg => {
    leg.shipments?.forEach(s => {
      const sId = s._id || s.id || s;
      if (!uniqueShipmentsObj[sId]) {
        uniqueShipmentsObj[sId] = typeof s === 'object' ? s : { _id: s, shipment_number: s };
      }
    });
  });
  const allTripShipments = Object.values(uniqueShipmentsObj);

  const isManual3PL = trip?.status === "3pl_assigned" || (trip?.platform && !["brickbucket", "own"].includes(trip.platform.toLowerCase()));

  const handleOtpChange = (stopId, val) => {
    setOtps(prev => ({ ...prev, [stopId]: val }));
  };

  const handleVerifyOtp = (stopId, stopType) => {
    console.log(`Verifying ${stopType} OTP for stop ${stopId}:`, otps[stopId]);
    alert(`${stopType} OTP verification triggered: ${otps[stopId]}`);
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity" onClick={onClose} />

      {/* Drawer Panel */}
      <div className="relative w-full max-w-2xl bg-white h-full shadow-2xl border-l border-slate-200 flex flex-col z-10 animate-in slide-in-from-right duration-300">
        
        {/* Top Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center text-orange-600">
              <Route className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-base font-bold text-slate-800">{trip.trip_number || trip.id}</h3>
                <Pill tone={tripDelivered ? "green" : tripInTransit ? "blue" : "slate"}>{trip.status}</Pill>
                {trip.type && <span className="text-[10px] uppercase font-bold bg-slate-100 text-slate-600 px-2 py-0.5 rounded">{trip.type}</span>}
              </div>
              <p className="text-xs text-slate-500 mt-0.5">
                Driver: <span className="font-semibold text-slate-700">{trip.partner_id?.name || "Unassigned"}</span> • {trip.partner_id?.vehicle_type || "Vehicle TBD"}
              </p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="flex items-center gap-2 px-6 pt-3 pb-2 border-b border-slate-200 bg-slate-50 overflow-x-auto">
          {[
            { key: "overview", label: "Trip Overview" },
            { key: "route", label: "Route & Stops", count: trip.route_legs?.length || 0 },
            { key: "shipments", label: "Shipments", count: allTripShipments.length },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                activeTab === tab.key 
                  ? "bg-white text-slate-800 shadow-xs border border-slate-200 font-semibold" 
                  : "text-slate-500 hover:text-slate-700 hover:bg-slate-100"
              }`}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span className={`text-[10px] px-1.5 py-0.2 rounded-full ${
                  activeTab === tab.key ? "bg-slate-100 text-slate-700" : "bg-slate-200/70 text-slate-500"
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Scrollable Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1 space-y-6">

          {/* 1. OVERVIEW TAB */}
          {(activeTab === "overview") && (
            <>
              <div className="grid grid-cols-4 gap-3">
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Trip ETA</div>
                  <div className="text-xs font-bold text-blue-700 mt-1 truncate">{trip.estimated_delivery_time || trip.eta || "Pending"}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Est. Distance</div>
                  <div className="text-xs font-bold text-slate-700 mt-1">{displayDistance || 0}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Est. Duration</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1">{displayDuration}</div>
                </div>
                <div className="border border-slate-200 rounded-lg p-3 bg-slate-50">
                  <div className="text-[11px] text-slate-400 font-medium">Total Shipments</div>
                  <div className="text-xs font-semibold text-slate-700 mt-1">{totalShipments}</div>
                </div>
              </div>

              {trip.partner_id && (
                <div className="border border-slate-200 rounded-xl p-4 bg-white shadow-xs flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                    <User className="w-6 h-6 text-slate-400" />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-bold text-slate-800">{trip.partner_id.name}</div>
                    <div className="text-xs text-slate-500 flex items-center gap-2 mt-0.5">
                      {/*<span className="flex items-center gap-1"><Phone className="w-3 h-3" /> {trip.partner_id.mobile || trip.partner_id.contact_number}</span>*/}
                      <button 
                        onClick={(e) => { 
                            e.stopPropagation(); 
                            // Dispatch custom event to bubble up or pass a direct prop
                            // Assuming onPhoneClick is added to TripTrackModal props:
                            if(window.handleGlobalPhoneClick) window.handleGlobalPhoneClick(trip.partner_id.mobile || trip.partner_id.contact_number);
                        }} 
                        className="flex items-center gap-1 text-blue-600 hover:underline cursor-pointer"
                      >
                         <Phone className="w-3 h-3" /> {trip.partner_id.mobile || trip.partner_id.contact_number}
                      </button>
                      <span>•</span>
                      <span className="flex items-center gap-1"><CarFront className="w-3 h-3" /> {trip.partner_id.vehicle_type} ({trip.partner_id.vehicle_number || "Reg TBD"})</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {/* 2. ROUTE & STOPS TAB (Detailed Breakdown) */}
          {(activeTab === "route") && (
            <div>
              <div className="flex items-center justify-between mb-4 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <Map className="w-4 h-4 text-orange-600" /> Route Execution Plan
                </div>
              </div>

              {(!trip.route_legs || trip.route_legs.length === 0) ? (
                <div className="p-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400 text-xs">
                  No routing stops or legs generated for this trip yet.
                </div>
              ) : (
                <div className="space-y-6">
                  {trip.route_legs.map((leg, legIdx) => {
                    
                    // Map shipments for this specific leg
                    const legShipments = leg.shipments?.map(s => {
                      if (typeof s === 'object') return s.shipment_number || s.so_number || s._id;
                      return s;
                    }) || [];

                    // Map the stops to fit the LiveTimeline component structure
/*                     const timelineSteps = leg.stops?.map(stop => ({
                      title: `Stop ${stop.stopSequence || ''}: ${stop.stopType || 'Waypoint'}`,
                      subtext: stop.location?.address || "Location pending",
                      eta: stop.plannedTime ? new Date(stop.plannedTime).toLocaleString("en-IN", { hour: '2-digit', minute: '2-digit', hour12: true, month: 'short', day: 'numeric' }) : "TBD",
                      done: stop.status === 'COMPLETED' || stop.status === 'SKIPPED',
                      distance: leg.distance ? `${leg.distance} km total leg` : undefined
                    })) || []; */

                    // Map the stops to fit the LiveTimeline component structure
                    const timelineSteps = leg.stops?.map((stop, idx) => {
                      const stopId = stop._id || `${leg._id || legIdx}-stop-${idx}`;
                      const isPickup = stop.stopType === 'PICKUP';
                      const isDropoff = stop.stopType === 'DROPOFF';
                      const showOtp = isManual3PL && stop.status !== 'COMPLETED' && stop.status !== 'SKIPPED' && (isPickup || isDropoff);

                      return {
                        title: `Stop ${stop.stopSequence || ''}: ${stop.stopType || 'Waypoint'}`,
                        subtext: stop.location?.address || "Location pending",
                        eta: stop.plannedTime ? new Date(stop.plannedTime).toLocaleString("en-IN", { hour: '2-digit', minute: '2-digit', hour12: true, month: 'short', day: 'numeric' }) : "TBD",
                        done: stop.status === 'COMPLETED' || stop.status === 'SKIPPED',
                        distance: leg.distance ? `${leg.distance} km total leg` : 0,
                        actionNode: showOtp ? (
                           <div className="flex gap-2 max-w-sm mt-1.5 p-2 bg-slate-50 rounded-lg border border-slate-200">
                              <input 
                                type="text" 
                                placeholder={`Enter ${isPickup ? 'Pickup' : 'Drop-off'} OTP`} 
                                value={otps[stopId] || ""} 
                                onChange={(e) => handleOtpChange(stopId, e.target.value)}
                                className="w-full text-xs rounded border border-slate-300 px-2 py-1.5 outline-none focus:border-blue-500 bg-white"
                              />
                              <button onClick={() => handleVerifyOtp(stopId, stop.stopType)} className="px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 whitespace-nowrap transition-colors">
                                Verify
                              </button>
                           </div>
                        ) : null
                      };
                    }) || [];

                    return (
                      <div key={leg._id || legIdx} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-sm">
                        {/* Leg Header */}
                        <div className="p-3 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
                          <div>
                            <div className="text-sm font-bold text-slate-800">
                              Route Leg {leg.sequence || legIdx + 1}
                            </div>
                            <div className="text-[11px] text-slate-500 mt-0.5 flex items-center gap-2">
                              <span>Type: <strong className="text-slate-700 capitalize">{leg.type ? leg.type.replace(/_/g, ' ') : 'Standard'}</strong></span>
                              {leg.distance && (
                                <>
                                  <span>•</span>
                                  <span>Distance: <strong className="text-slate-700">{leg.distance || 0} km</strong></span>
                                </>
                              )}
                            </div>
                          </div>
                          <Pill tone={leg.status === 'completed' ? 'green' : leg.status === 'in_transit' ? 'blue' : 'slate'}>
                            {leg.status || 'Pending'}
                          </Pill>
                        </div>

                        <div className="p-4">
                          {/* Shipments carried in this specific leg */}
                          <div className="mb-5">
                            <div className="text-[10px] font-bold text-slate-500 uppercase mb-2">Shipments Transported in this Leg</div>
                            {legShipments.length > 0 ? (
                              <div className="flex flex-wrap gap-2">
                                {legShipments.map((sNum, sIdx) => (
                                  <span key={sIdx} className="px-2.5 py-1 bg-blue-50 border border-blue-100 text-blue-700 rounded text-[11px] font-semibold flex items-center gap-1.5">
                                    <PackageCheck className="w-3 h-3" /> {sNum}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <div className="text-xs text-slate-400">No shipments linked directly to this leg.</div>
                            )}
                          </div>

                          {/* Stops Timeline for this leg */}
                          <div>
                            <div className="text-[10px] font-bold text-slate-500 uppercase mb-2">Stops & Waypoints</div>
                            {timelineSteps.length > 0 ? (
                              <div className="bg-slate-50 border border-slate-100 rounded-lg p-3 pt-4 pb-0">
                                <LiveTimeline steps={timelineSteps} />
                              </div>
                            ) : (
                              <div className="text-xs text-slate-400 border border-slate-100 rounded-lg p-3 bg-slate-50">No stops defined.</div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* 3. SHIPMENTS TAB */}
          {(activeTab === "shipments") && (
            <div>
              <div className="flex items-center justify-between mb-4 border-b border-slate-200 pb-2">
                <div className="text-xs font-bold text-slate-600 uppercase tracking-wide flex items-center gap-1.5">
                  <PackageCheck className="w-4 h-4 text-green-600" /> All Shipments on Trip ({allTripShipments.length})
                </div>
              </div>

              {allTripShipments.length === 0 ? (
                <div className="p-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400 text-xs">
                  No shipments attached to this trip.
                </div>
              ) : (
                <div className="space-y-3">
                  {allTripShipments.map((s, idx) => (
                    <div key={s._id || idx} className="border border-slate-200 rounded-xl p-3.5 bg-white shadow-xs flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
                          <PackageCheck className="w-5 h-5 text-slate-500" />
                        </div>
                        <div>
                          <div className="text-sm font-bold text-slate-800">{s.shipment_number || s.so_number || s._id}</div>
                          <div className="text-[11px] text-slate-500 mt-0.5 flex items-center gap-2">
                            {s.origin?.name && <span>Origin: <strong className="text-slate-700">{s.origin.name}</strong></span>}
                            {s.origin?.name && s.destination?.name && <span>•</span>}
                            {s.destination?.name && <span>Dest: <strong className="text-slate-700">{s.destination.name}</strong></span>}
                          </div>
                          <div className="text-[10px] text-slate-400 mt-0.5">
                            Weight: {s.weight || 'N/A'} {s.weight ? 'kg' : ''} • Vol: {s.volume || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <Pill tone={s.status === 'Delivered' ? 'green' : 'blue'}>{s.status || 'In Transit'}</Pill>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

        </div>

        {/* Drawer Footer */}
        <div className="px-6 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-xs text-slate-500">
          <div>
            Viewing detailed telemetry for Trip <strong className="text-slate-700">{trip.trip_number || trip.id}</strong>
          </div>
          <button 
            onClick={onClose} 
            className="px-4 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 font-medium hover:bg-slate-100 transition-colors"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Create Trip Modal (Generated from Shipments)                           */
/* ---------------------------------------------------------------------- */
function CreateTripModal({ shipmentsData,selectedShipmentIds, onClose, onRefresh }) {
  const shipments = shipmentsData.filter(s => selectedShipmentIds.has(s.id));
  
  const generatedRouteLegs = shipments.map((s, index) => ({
      title: `Waypoint ${index + 1}: ${s.destination}`,
      subtext: `Drop off for ${s.id}`,
      distance: `${(index + 1) * 12.5} km`,
      eta: `13 Sep, 1${index + 2}:00`,
      done: false,
      shipments: [s.id]
  }));

  const originLeg = {
      title: "Depart Origin",
      subtext: "Auto Nagar Hub",
      distance: "0 km",
      eta: "13 Sep, 10:00",
      done: false,
      shipments: shipments.map(s => s.id)
  };

  const legs = [originLeg, ...generatedRouteLegs];


const createOrUpdateTrip = async (tripData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/create-or-update-trip`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(tripData)
    });
    
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Error in createOrUpdateTrip:", error);
    throw error;
  }
}; 


const handleConfirmTrip = async () => {
    try {
      // 1. Just extract the IDs from the selected shipments
      const shipmentIds = shipments.map(s => s._id || s.id);

      const payload = {
        shipment_ids: shipmentIds
      };

      const token = decryptData(sessionStorage.getItem("token"));
      
      // 2. Point to the new API endpoint
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/create-trip-from-shipments`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-token': token || ""
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      if (result.success || response.ok) {
        if (onRefresh) onRefresh();
        onClose();
      } else {
        alert(result.message || "Failed to create trip");
      }
    } catch (error) {
      console.error("Error creating trip:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-3xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Review & Create Trip</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          <div className="text-sm font-medium text-slate-800 mb-4">Generated Route Legs</div>
          <div className="border border-slate-200 rounded-lg p-5 bg-slate-50">
             <LiveTimeline steps={legs} />
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-600 rounded-lg border border-slate-200 hover:bg-slate-50">Cancel</button>
          <button onClick={handleConfirmTrip} className="px-4 py-2 text-sm font-medium text-white rounded-lg" style={{ backgroundColor: ACCENT }}>
          Confirm & Create Trip
          </button>
      </div>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Create Shipment Modal with Item Removal                                */
/* ---------------------------------------------------------------------- */
function CreateShipmentModal({ initialItems, onClose, onRefresh }) {
  const [items, setItems] = useState(initialItems);
  const [route, setRoute] = useState(initialItems[0]?.route || "Via Hub");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const removeItem = (uniqueKey) => setItems(prev => prev.filter(item => item.uniqueKey !== uniqueKey));

  // Determine Origin & Destination from the first item in the shipment list
  const refItem = items[0] || {};
  
  const dynamicOrigin = {
    name: refItem.supplier || "Supplier",
    address: refItem.supplierAddress || "Address not provided",
    latitude: refItem.supplierLat,
    longitude: refItem.supplierLng
  };

  const dynamicDestination = route === "Via Hub" ? {
    name: "Hub",
    address: refItem.hubAddress || "Hub address not provided",
    latitude: refItem.hubLat,
    longitude: refItem.hubLng
  } : {
    name: "Customer Site",
    address: refItem.customerAddress || "Customer address not provided",
    latitude: refItem.customerLat,
    longitude: refItem.customerLng
  };

  const createOrUpdateShipment = async (shipmentData) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/create-or-update-shipment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(shipmentData)
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error in createOrUpdateShipment:", error);
      throw error;
    }
  };

  // Helper to extract numbers from weight strings (e.g., "12,000 kg" -> 12000)
  const parseNumber = (val) => {
    if (!val) return 0;
    if (typeof val === 'number') return val;
    const num = String(val).replace(/,/g, '').match(/[\d.]+/);
    return num ? parseFloat(num[0]) : 0;
  };

  const handleConfirmShipment = async () => {
    setIsSubmitting(true);

    try {
      // 1. Extract unique Order Numbers and DG references
      const so_number = [...new Set(items.map(i => i.orderNumber))].join(", ");
      
      // Note: If you have actual MongoDB ObjectIds for DGs, map them here. 
      // Falling back to dgNumber if the ID isn't directly available on the item.
      const dg_ids = [...new Set(items.map(i => i.dg_id || i.dgNumber))];
      const po_ids = [...new Set(items.map(i => i.po_id || i.po))];

      // 2. Format items to match ShipmentSchema
      const formattedItems = items.map(item => ({
        itemId: item.id,
        quantity: item.qty,
        itemName: item.name,
        itemImage: item.image,
        dimensions: typeof item.dimensions === 'object' ? item.dimensions : { length: 0, width: 0, height: 0, unit: 'cm' },
        itemWeight: parseNumber(item.weight?.value || item.weight),
        po_number: item.po,
        so_number: item.orderNumber,
        dg_number: item.dgNumber,
        shipment_image:item.packed_image
      }));

      // 3. Calculate total weight & volume
      const totalWeight = items.reduce((sum, item) => sum + parseNumber(item.weight?.value || item.weight), 0);
      const totalVolume = items.reduce((sum, item) => sum + parseNumber(item.volume), 0);

      // 4. Construct the payload
      const payload = {
        so_number: so_number,
        dg_ids: dg_ids,
        po_ids: po_ids,
        delivery_date: new Date().toISOString(), // Or a date selected from the UI
        status: "Pending",
        items: formattedItems,
        weight: totalWeight,
        volume: totalVolume,
        origin: dynamicOrigin,
        destination: dynamicDestination,
        shipment_image:formattedItems[0]?.shipment_image
      };

      // 5. Fire API
      const result = await createOrUpdateShipment(payload);

      console.log("create shipment:", result);
      
      if (result.success) {
        if (onRefresh) onRefresh();
        // Optional: Trigger a success toast or refresh parent list here
        onClose();
      } else {
        alert(result.message || "Failed to create shipment");
      }
    } catch (error) {
      alert("Error: " + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">Create Shipment</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-3 gap-4 mb-4">
            
            {/* Dynamic Origin Display (FIXED OBJECT RENDERING) */}
            <div className="border border-slate-200 p-3 rounded-lg bg-slate-50">
              <div className="text-xs text-slate-500 font-medium mb-1">Origin ({dynamicOrigin.name})</div>
              <div className="text-sm font-medium truncate" title={dynamicOrigin.address}>{dynamicOrigin.address}</div>
            </div>
            
            {/* Dynamic Destination Display (FIXED OBJECT RENDERING) */}
            <div className="border border-slate-200 p-3 rounded-lg bg-slate-50">
              <div className="text-xs text-slate-500 font-medium mb-1">Destination ({dynamicDestination.name})</div>
              <div className="text-sm font-medium truncate" title={dynamicDestination.address}>{dynamicDestination.address}</div>
            </div>
            
            {/* Route Selector Updates UI State Immediately */}
            <div className="border border-slate-200 p-3 rounded-lg bg-slate-50">
              <div className="text-xs text-slate-500 mb-1 font-medium">Recommended Route</div>
              <select 
                value={route} 
                onChange={(e) => setRoute(e.target.value)} 
                className="w-full text-sm bg-white border border-slate-300 rounded outline-none p-1 font-medium text-blue-600"
              >
                <option value="Via Hub">Via Hub</option>
                <option value="Direct">Direct</option>
              </select>
            </div>
          </div>
          
          <div className="flex justify-between items-center mb-2">
             <div className="text-sm font-medium text-slate-800">Items in Shipment ({items.length})</div>
          </div>
          
          <div className="border border-slate-200 rounded-lg overflow-hidden max-h-64 overflow-y-auto">
            {items.length === 0 ? (
               <div className="p-4 text-sm text-slate-500 text-center">No items selected.</div>
            ) : (
              items.map((item) => (
                <div key={item.uniqueKey} className="flex justify-between items-center px-4 py-3 border-b border-slate-100 last:border-b-0 text-sm text-slate-700">
                  <div>
                    <div className="font-medium">{item.name}</div>
                    <div className="text-xs text-slate-500">
                      PO: {item.po} | DG: {item.dgNumber} | Qty: {item.qty} | Supplier: {item.supplier}
                    </div>
                  </div>
                  <button onClick={() => removeItem(item.uniqueKey)} className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors">
                     <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200">
          <button onClick={onClose} disabled={isSubmitting} className="px-4 py-2 text-sm text-slate-600 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-50">Cancel</button>
          
          <button 
            disabled={items.length === 0 || isSubmitting} 
            onClick={handleConfirmShipment} 
            className="px-4 py-2 text-sm font-medium text-white rounded-lg disabled:opacity-50 flex items-center gap-2" 
            style={{ backgroundColor: "#f7525a" }}
          >
            {isSubmitting ? "Creating..." : "Confirm Shipment"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Screen 1 — Orders                                                      */
/* ---------------------------------------------------------------------- */
function OrdersScreen({ orders, onTrackOrder, onTrackDg,onRefresh }) {
  const [expandedOrderIds, setExpandedOrderIds] = useState([]);
  const [expandedDgIds, setExpandedDgIds] = useState([]);
  const [selectedItemKeys, setSelectedItemKeys] = useState(new Set()); // Uses composite keys now
  const [showCreateShipment, setShowCreateShipment] = useState(false);

  const {
    currentItems: paginatedOrders,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    handlePreviousPage,
    handleNextPage,
  } = usePagination(orders || [], 5);

  // Helper to generate a globally unique key for each line item
  const getItemKey = (orderNum, dgNum, poNum, itemId) => {
    return `${orderNum}_${dgNum}_${poNum}_${itemId}`;
  };

  const toggleOrder = (id) => {
    setExpandedOrderIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  
  const toggleDg = (id) => {
    setExpandedDgIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleSelectDg = (dg, order, checked) => {
    const newSel = new Set(selectedItemKeys);
    dg.items.forEach(item => {
      const itemDelivered = item.status?.toLowerCase() === "delivered" || dg.status?.toLowerCase() === "delivered";
      // Only allow selection of items that are NOT delivered
      if (!itemDelivered) {
        const key = getItemKey(order.orderNumber, dg.dg, item.po, item.id);
        if (checked) newSel.add(key); else newSel.delete(key);
      }
    });
    setSelectedItemKeys(newSel);
  };

  const handleSelectItem = (itemKey, checked) => {
    const newSel = new Set(selectedItemKeys);
    if (checked) newSel.add(itemKey); else newSel.delete(itemKey);
    setSelectedItemKeys(newSel);
  };

  const isDgFullySelected = (dg, order) => {
    const selectableItems = dg.items.filter(item => !(item.status?.toLowerCase() === "delivered" || dg.status?.toLowerCase() === "delivered"));
    if (selectableItems.length === 0) return false; // If everything is delivered, checkbox is technically unchecked/disabled

    return selectableItems.every(item => {
      const key = getItemKey(order.orderNumber, dg.dg, item.po, item.id);
      return selectedItemKeys.has(key);
    });
  };

  const getSelectedItemsData = () => {
    const items = [];
    orders.forEach(order => {
      order.deliveryGroups.forEach(dg => {
        dg.items.forEach(item => {
          const key = getItemKey(order.orderNumber, dg.dg, item.po, item.id);
          if (selectedItemKeys.has(key)) {
            items.push({
              ...item,
              uniqueKey: key, 
              orderNumber: order.orderNumber,
              dgNumber: dg.dg,
              dg_id: dg.dg_id,
            });
          }
        });
      });
    });
    return items;
  };

  return (
    <div className="flex flex-col mb-10">
      <TopBar placeholder="Search orders, items..." primaryLabel="Create Shipment" onPrimary={() => {
        if (selectedItemKeys.size > 0) setShowCreateShipment(true);
        else alert("Select items first");
      }} />
      
      <div className="border border-slate-200 rounded-xl bg-white flex flex-col shadow-sm w-full">
        <div className="overflow-auto max-h-[calc(100vh-380px)] min-h-[300px] flex-1">
          <table className="w-full min-w-[1200px] border-collapse relative">
            <colgroup>
              <col style={{ width: "350px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "180px" }} />
              <col style={{ width: "100px" }} />
              <col style={{ width: "100px" }} />
            </colgroup>
            <tbody>
              {paginatedOrders?.length === 0 ? (
              <tr>
                  <td colSpan={9} className="py-16 text-center text-gray-500 border border-gray-100 rounded-lg">
                    <div className="flex flex-col items-center justify-center w-full">
                      <Package className="w-8 h-8 mb-2 text-gray-400" />
                      <p className="text-sm font-medium">No Orders Found</p>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedOrders?.map((order) => {
                  const isOrderOpen = expandedOrderIds.includes(order.orderNumber);
                  return (
                    <React.Fragment key={order.orderNumber}>
                      {/* Order Level Row */}
                      <tr className="bg-slate-50 border-b border-slate-200 hover:bg-slate-100 cursor-pointer sticky top-0 z-10" onClick={() => toggleOrder(order.orderNumber)}>
                        <Td>
                          <div className="flex items-center gap-2 font-semibold text-slate-800 pl-2">
                            <ChevronRight className={`w-4 h-4 text-slate-400 transition-transform ${isOrderOpen ? "rotate-90" : ""}`} />
                            {order.orderNumber}
                          </div>
                        </Td>
                        <Td colSpan={2}>
                          <div className="text-sm text-slate-600">
                            <span className="font-medium text-slate-500">Order ETA:</span> {new Date(order.eta).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
                            })}
                          </div>
                        </Td>
                        <Td colSpan={3}>
                          <div className="text-sm text-slate-600"><span className="font-medium text-slate-500">Time Remaining:</span> {order.remaining}</div>
                        </Td>
                        <Td></Td>
                        <Td><Pill tone="green">{order.status}</Pill></Td>
                        <Td onClick={(e) => e.stopPropagation()}>
                          <button onClick={() => onTrackOrder(order)} className="px-3 py-1 text-xs border rounded-md text-blue-600 border-blue-200 hover:bg-blue-50 w-full">Track</button>
                        </Td>
                      </tr>
                      
                      {/* Expanded Order Content */}
                      {isOrderOpen && order.deliveryGroups.map(dg => {
                        const isDgOpen = expandedDgIds.includes(dg.dg);
                        const dgChecked = isDgFullySelected(dg, order);
                        const dgDelivered = dg.status?.toLowerCase() === "delivered";

                        return (
                          <React.Fragment key={dg.dg}>
                            {/* Delivery Group Row */}
                            <tr className="bg-white border-b border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => toggleDg(dg.dg)}>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1 pl-[60px]">Delivery Group</div>
                                <div className="flex items-center gap-3 pl-8">
                                  {dgDelivered ? (
                                    <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" title="Delivered" />
                                  ) : (
                                    <input type="checkbox" checked={dgChecked} onChange={(e) => handleSelectDg(dg, order, e.target.checked)} className="rounded border-slate-300 w-4 h-4 cursor-pointer shrink-0" onClick={(e) => e.stopPropagation()} />
                                  )}
                                  <ChevronRight className={`w-3.5 h-3.5 text-slate-400 transition-transform ${isDgOpen ? "rotate-90" : ""}`} />
                                  <span className="text-sm font-bold">{dg.dg}</span>
                                </div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">ETA</div>
                                <div className="text-xs text-slate-500">
                                {new Date(dg.eta).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })}
                                </div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Remaining</div>
                                <div><Pill tone="amber">{dg.remaining}</Pill></div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Dist to Hub</div>
                                <div className="text-sm text-slate-700">{dg.distHub}</div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Dist to Cust</div>
                                <div className="text-sm text-slate-700">{dg.distCustomer}</div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Route</div>
                                <div className="text-sm font-medium text-slate-700">{dg.route}</div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Supplier(s)</div>
                                <div className="text-xs text-slate-500 whitespace-pre-wrap">{dg.suppliers}</div>
                              </Td>
                              <Td>
                                <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Status</div>
                                <div><Pill tone="blue">{dg.status}</Pill></div>
                              </Td>
                              <Td onClick={(e) => e.stopPropagation()} className="align-bottom pb-3">
                                 <button onClick={() => onTrackDg(dg, order)} className="px-3 py-1 text-xs border rounded-md text-blue-600 border-blue-200 hover:bg-blue-50 w-full">Track</button>
                              </Td>
                            </tr>
                            
                            {/* Item Rows */}
                            {isDgOpen && dg.items.map(item => {
                              const Icon = CATEGORY_ICON[item.category] || Package;
                              const itemKey = getItemKey(order.orderNumber, dg.dg, item.po, item.id);
                              const isChecked = selectedItemKeys.has(itemKey);
                              const itemDelivered = item.status?.toLowerCase() === "delivered" || dg.status?.toLowerCase() === "delivered";
                              
                              return (
                                <tr 
                                  key={itemKey} 
                                  className={`bg-slate-50/50 border-b border-slate-100 ${!itemDelivered ? "hover:bg-slate-100 cursor-pointer" : "opacity-80"}`} 
                                  onClick={() => { if (!itemDelivered) handleSelectItem(itemKey, !isChecked); }}
                                >
                                  <Td colSpan={6}>
                                    <div className="flex items-center gap-4 pl-16 py-1">
                                      {itemDelivered ? (
                                        <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" title="Delivered" />
                                      ) : (
                                        <input type="checkbox" checked={isChecked} onChange={(e) => handleSelectItem(itemKey, e.target.checked)} className="rounded border-slate-300 w-4 h-4 cursor-pointer shrink-0" onClick={(e) => e.stopPropagation()} />
                                      )}
                                      
                                      <div className="flex items-center gap-3 w-56 shrink-0">
                                        <div className="group relative flex items-center shrink-0">
                                          <div className="w-8 h-8 rounded bg-white border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden">
                                            {item?.image ? (
                                              <img src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`} alt={item?.name || ""} className="w-full h-full object-cover" />
                                            ) : (
                                              <Icon className="w-4 h-4 text-slate-500" />
                                            )}
                                          </div>
                                        </div>
                                        <div className="text-sm font-medium text-slate-800 truncate" title={item.name}>{item.name}</div>
                                      </div>

                                      <div className="flex gap-5 text-xs text-slate-500 flex-1">
                                        <div><span className="font-medium text-slate-700">PO:</span> {item.po}</div>
                                        <div><span className="font-medium text-slate-700">Qty:</span> {`${item.qty} ${item.UOM || ''}`}</div>
                                        <div><span className="font-medium text-slate-700">Wt:</span> {typeof item.weight === 'object' ? `${item.weight.value} ${item.weight.unit}` : item.weight}</div>
                                        <div><span className="font-medium text-slate-700">Vol:</span> {item.volume}</div>
                                        <div><span className="font-medium text-slate-700">Dist (Hub):</span> {item.distHub} km</div>
                                        <div><span className="font-medium text-slate-700">Dist (Cust):</span> {item.distCustomer} km</div>
                                        <div><span className="font-medium text-slate-700">Route:</span> {item.route} </div>
                                      </div>
                                    </div>
                                  </Td>
                                  <Td className="text-xs text-slate-500">{item.supplier}</Td>
                                  <Td><Pill tone={itemDelivered ? "green" : "slate"}>{item.status}</Pill></Td>
                                  <Td></Td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="border-t border-slate-200 px-4 pt-4 pb-4 bg-slate-50 rounded-b-xl shrink-0">
            <Pagination currentPage={currentPage} totalPages={totalPages} totalItems={totalItems} itemsPerPage={5} onPageChange={handlePageChange} onPreviousPage={handlePreviousPage} onNextPage={handleNextPage} showInfo={true} itemName="Orders" />
          </div>
        )}
      </div>

      {showCreateShipment && <CreateShipmentModal initialItems={getSelectedItemsData()} onClose={() => setShowCreateShipment(false)} onRefresh={onRefresh}/>}
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Screen 2 — Shipments                                                   */
/* ---------------------------------------------------------------------- */
function ShipmentsScreen({ shipments,onTrack, onCreateTrip }) {
  const [expandedShipments, setExpandedShipments] = useState([]);
  const [selectedShipmentIds, setSelectedShipmentIds] = useState(new Set());
  
  const toggleShipment = (id) => {
    setExpandedShipments(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleSelectShipment = (id, checked) => {
    const newSel = new Set(selectedShipmentIds);
    if (checked) newSel.add(id); else newSel.delete(id);
    setSelectedShipmentIds(newSel);
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedShipmentIds(new Set(shipments.map(s => s.id)));
    } else {
      setSelectedShipmentIds(new Set());
    }
  };

  return (
    <div>
      <TopBar placeholder="Search shipments..." primaryLabel="Create Trip" onPrimary={() => {
         if (selectedShipmentIds.size > 0) onCreateTrip(selectedShipmentIds);
         else alert("Select shipments first");
      }} />
      {(!shipments || shipments.length === 0) ? (<div className="flex flex-col items-center justify-center w-full py-16 text-gray-500 bg-white border border-gray-100 rounded-lg shadow-sm">
          <Package className="w-8 h-8 mb-2 text-gray-400" /> {/* Import Truck from lucide-react */}
          <p className="text-sm font-medium">No Shipments Found</p>
        </div>
      ):(
            <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
              <table className="w-full border-collapse">
                <thead className="bg-slate-50 border-b border-slate-200">
                  <tr>
                    <Th className="w-12 text-center">
                      <input type="checkbox" onChange={(e) => handleSelectAll(e.target.checked)} checked={selectedShipmentIds.size === SHIPMENTS.length && SHIPMENTS.length > 0} className="rounded border-slate-300 w-4 h-4 cursor-pointer" />
                    </Th>
                    <Th className="w-10"></Th>
                    <Th>Shipment</Th>
                    <Th>Origin</Th>
                    <Th>Destination</Th>
                    <Th>ETA</Th>
                    <Th>Status</Th>
                    <Th>Track</Th>
                  </tr>
                </thead>
                <tbody>
                  {shipments?.map((s) => {
                    const currentId = s._id || s.id;
                    console.log(currentId)
                    const isOpen = expandedShipments.includes(s.id);
                    const isSelected = selectedShipmentIds.has(s.id);
                    return (
                      <React.Fragment key={currentId}>
                        <tr className="border-b border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => toggleShipment(currentId)}>
                          <Td className="text-center" onClick={(e) => e.stopPropagation()}>
                            <input type="checkbox" checked={isSelected} onChange={(e) => handleSelectShipment(currentId, e.target.checked)} className="rounded border-slate-300 w-4 h-4 cursor-pointer" />
                          </Td>
                          <Td><ChevronRight className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? "rotate-90" : ""}`} /></Td>
                          <Td>
                            <div className="flex items-center gap-3">
                              <div className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
                                 {s?.image ? (
                                    <img src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${s?.image}`} alt={s?.shipment_number || ""} className="w-full h-full object-cover" />
                                  ) : (
                                    <PackageCheck className="w-4.5 h-4.5 text-slate-600" />
                                  )}
                              </div>
                              <div>
                                <div className="font-medium text-slate-800">{s.shipment_number}</div>
                                <div className="text-xs text-slate-400">{s.weight}</div>
                              </div>
                            </div>
                          </Td>
                          <Td>{s.origin}</Td>
                          <Td>{s.destination}</Td>
                          <Td>{s.eta}</Td>
                          <Td><Pill tone="blue">{s.status}</Pill></Td>
                          <Td onClick={(e) => e.stopPropagation()}>
                            <button onClick={() => onTrack(s)} className="px-3 py-1.5 text-xs font-medium rounded-md border text-blue-600 border-blue-200 hover:bg-blue-50">Track</button>
                          </Td>
                        </tr>
                        {isOpen &&
                          s.items.map((item) => {
                            const Icon = CATEGORY_ICON[item.category] || Package;

                            return (
                              <tr
                                key={item.id}
                                className="bg-slate-50/50 border-b border-slate-100"
                              >
                                <Td></Td>
                                <Td></Td>
                                <Td colSpan={6}>
                                  <div className="flex items-center gap-6 pl-4">
                                    <div className="w-8 h-8 rounded bg-white border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden">
                                      {item?.image ? (
                                        <img
                                          src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`}
                                          alt={item?.name || ""}
                                          className="w-full h-full object-cover"
                                        />
                                      ) : (
                                        <Icon className="w-4 h-4 text-slate-500" />
                                      )}
                                    </div>
                                    <div className="text-sm font-medium text-slate-800 w-64">
                                      {item.name}
                                    </div>
                                    <div className="flex gap-8 text-xs text-slate-500">
                                      <div>
                                        <span className="font-medium text-slate-700">Qty:</span>{" "}
                                        {item.qty}
                                      </div>
                                      <div>
                                        <span className="font-medium text-slate-700">Wt:</span>{" "}
                                        {item.weight}
                                      </div>
                                      <div>
                                        <span className="font-medium text-slate-700">Dim:</span>{" "}
                                        {item.dimensions}
                                      </div>
                                      <div>
                                        <Pill tone="slate">{item.status}</Pill>
                                      </div>
                                    </div>
                                  </div>
                                </Td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
      )}
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Screen 3 — Trips                                                       */
/* ---------------------------------------------------------------------- */
/*function TripsScreen({ trips,onAssign, onTrack, onViewShipments, onViewRouteLegs }) {
  return (
    <div>
      {(!trips || trips.length === 0)?(
        <div className="flex flex-col items-center justify-center w-full py-16 text-gray-500 bg-white border border-gray-100 rounded-lg shadow-sm">
          <Route className="w-8 h-8 mb-2 text-gray-400" /> 
          <p className="text-sm font-medium">No Trips Found</p>
        </div>
      ):(
      <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
        <table className="w-full border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <Th>Trip ID</Th>
              <Th>Shipments</Th>
              <Th>Route Legs</Th>
              <Th>ETA</Th>
              <Th>Time Remaining</Th>
              <Th>Status</Th>
              <Th>Assign Partner</Th>
              <Th>Track</Th>
            </tr>
          </thead>
          <tbody>
            {trips.map((t) => {
              // Calculate total shipments across all legs
              const totalShipments = t.route_legs?.reduce((acc, leg) => acc + (leg.shipments?.length || 0), 0) || 0;
              const legCount = t.route_legs?.length || 0;

              return (
              <tr key={t._id} className="border-b border-slate-100 hover:bg-slate-50">
                <Td className="text-xs font-medium">{t.trip_number}</Td>
                <Td>
                  <button onClick={() => onViewShipments(t)} className="text-blue-600 hover:underline font-medium">
                     {totalShipments} shipments
                  </button>
                </Td>
                <Td>
                   <button onClick={() => onViewRouteLegs(t)} className="text-blue-600 hover:underline font-medium">
                     {legCount} Legs
                   </button>
                </Td>
                <Td>{t.estimated_delivery_time || 'N/A'}</Td>
                <Td><Pill tone="amber">{t.isDelayed ? "Delayed" : "On Time"}</Pill></Td>
                <Td><Pill tone={t.status === "in_transit" ? "blue" : "slate"}>{t.status}</Pill></Td>
                <Td>
                  {t.partner_id ? (
                     <div className="flex items-center gap-3">
                        <div>
                          <div className="text-sm font-medium text-slate-800">{t.partner_id.name}</div>
                          <div className="text-xs text-slate-500">{t.partner_id.vehicle_type}</div>
                          <div className="text-xs text-slate-500">{t.partner_id.mobile}</div>
                        </div>
                        <button onClick={() => onAssign(t, true)} className="p-1.5 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded border border-transparent hover:border-slate-200">
                           <Edit2 className="w-3.5 h-3.5" />
                        </button>
                     </div>
                  ) : (
                    <button onClick={() => onAssign(t, false)} className="px-3 py-1.5 text-xs font-medium rounded-md text-white" style={{ backgroundColor: ACCENT }}>Assign</button>
                  )}
                </Td>
                <Td>
                  <button onClick={() => onTrack(t)} className="px-3 py-1.5 text-xs font-medium rounded-md border text-blue-600 border-blue-200 hover:bg-blue-50">Track</button>
                </Td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
}*/

// Add onPhoneClick to your props
function TripsScreen({ trips, onAssign, onTrack, onViewShipments, onViewRouteLegs, onPhoneClick }) {
  return (
    <div>
      {(!trips || trips.length === 0)?(
        <div className="flex flex-col items-center justify-center w-full py-16 text-gray-500 bg-white border border-gray-100 rounded-lg shadow-sm">
          <Route className="w-8 h-8 mb-2 text-gray-400" />
          <p className="text-sm font-medium">No Trips Found</p>
        </div>
      ):(
      <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
        <table className="w-full border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <Th>Trip ID</Th>
              <Th>Shipments</Th>
              <Th>Route Legs</Th>
              <Th>ETA</Th>
              <Th>Time Remaining</Th>
              <Th>Status</Th>
              <Th>Assign Partner</Th>
              <Th>Track</Th>
            </tr>
          </thead>
          <tbody>
            {trips.map((t) => {
              const totalShipments = t.route_legs?.reduce((acc, leg) => acc + (leg.shipments?.length || 0), 0) || 0;
              const legCount = t.route_legs?.length || 0;

              return (
              <tr key={t._id} className="border-b border-slate-100 hover:bg-slate-50">
                <Td className="text-xs font-medium">{t.trip_number}</Td>
                <Td>
                  <button onClick={() => onViewShipments(t)} className="text-blue-600 hover:underline font-medium">
                     {totalShipments} shipments
                  </button>
                </Td>
                <Td>
                   <button onClick={() => onViewRouteLegs(t)} className="text-blue-600 hover:underline font-medium">
                     {legCount} Legs
                   </button>
                </Td>
                <Td>{t.estimated_delivery_time || 'N/A'}</Td>
                <Td><Pill tone="amber">{t.isDelayed ? "Delayed" : "On Time"}</Pill></Td>
                <Td><Pill tone={t.status === "in_transit" ? "blue" : "slate"}>{t.status}</Pill></Td>
                <Td>
                  {t.partner_id ? (
                     <div className="flex items-center gap-3">
                        <div>
                          <div className="text-sm font-medium text-slate-800">{t.partner_id.name}</div>
                          <div className="text-xs text-slate-500 mb-0.5">{t.partner_id.vehicle_type}</div>
                          {/* UPDATED: Interactive Mobile Number */}
                          <button 
                            onClick={(e) => { e.stopPropagation(); onPhoneClick(t.partner_id.mobile); }}
                            className="text-xs text-blue-600 hover:underline flex items-center gap-1 transition-colors"
                          >
                            <Phone className="w-3 h-3" /> {t.partner_id.mobile}
                          </button>
                        </div>
                        <button onClick={() => onAssign(t, true)} className="p-1.5 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded border border-transparent hover:border-slate-200">
                           <Edit2 className="w-3.5 h-3.5" />
                        </button>
                     </div>
                  ) : (
                    <button onClick={() => onAssign(t, false)} className="px-3 py-1.5 text-xs font-medium rounded-md text-white" style={{ backgroundColor: ACCENT }}>Assign</button>
                  )}
                </Td>
                <Td>
                  <button onClick={() => onTrack(t)} className="px-3 py-1.5 text-xs font-medium rounded-md border text-blue-600 border-blue-200 hover:bg-blue-50">Track</button>
                </Td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
}

const FLEET_STEP_OPTIONS = ["Brickbucket", "3 PL", "On Demand", "Supplier"];
const VEHICLE_STEP_OPTIONS = [
  { label: "Bike", icon: Bike },
  { label: "Passenger Auto", icon: Car },
  { label: "Truck Auto", icon: Truck },
  { label: "Truck Van", icon: Truck },
];

/*function TripWizard({ mode, partners, trip, onClose, onRefresh }) {
  const [step, setStep] = useState(1);
  const [deliveryType, setDeliveryType] = useState("Direct");
  const [priority, setPriority] = useState("Medium");
  const [notes, setNotes] = useState("");
  const [fleet, setFleet] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [partner, setPartner] = useState(trip?.partner_id || null);

  const isAssign = mode === "assign";
  const allSteps = isAssign 
     ? ["Select Fleet", "Vehicle Type", "Select Partner"] 
     : ["Type & Priority", "Select Fleet", "Vehicle Type", "Select Partner"];
     
  const title = isAssign ? "Assign / Edit Fleet & Partner" : "Create Trip";
  const currentStepLabel = allSteps[step - 1];
  const canProceed = 
      (currentStepLabel === "Type & Priority") || 
      (currentStepLabel === "Select Fleet" && fleet) ||
      (currentStepLabel === "Vehicle Type" && vehicle) ||
      (currentStepLabel === "Select Partner" && partner);

  const createOrUpdateTrip = async () => {
      try {
        const payload = {
          type: deliveryType,
          priority: priority,
          notes: notes,
          partner_id: partner?._id || undefined,
          status: partner ? "assigned" : "draft"
        };

        if (mode === "assign" && trip?._id) {
          payload.trip_id = trip._id;
        }

        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/create-or-update-trip`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': decryptData(sessionStorage.getItem("token"))
          },
          body: JSON.stringify(payload)
        });
        
        const result = await response.json();
        if(result.success) onClose();
      } catch(err) {
        console.error(err);
      }
    };

const editTripAssignment = async () => {
    try {
      const payload = {
        trip_id: trip._id,
        partner_id: partner?._id || undefined,
        // vehicle_id: vehicle?._id // If tracking vehicle ObjectIds separately
      };

      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/edit-trip-assignment`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-token': token || ""
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      if (result.success || response.ok) {
        if (onRefresh) onRefresh();
        onClose();
      } else {
        alert(result.message || "Failed to assign partner");
      }
    } catch (error) {
      console.error("Assignment error:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 max-h-[92vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">{title}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>

        <div className="flex items-center gap-2 px-6 pt-4">
          {allSteps.map((label, i) => (
            <div key={label} className="flex items-center gap-2 flex-1">
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-medium shrink-0" style={{ backgroundColor: step > i + 1 ? SUCCESS : step === i + 1 ? ACCENT : "#e2e8f0", color: step >= i + 1 ? "#fff" : "#64748b" }}>
                {step > i + 1 ? <Check className="w-3 h-3" /> : i + 1}
              </div>
              <span className={`text-xs ${step === i + 1 ? "text-slate-700 font-medium" : "text-slate-400"}`}>{label}</span>
              {i < allSteps.length - 1 && <div className="flex-1 h-px bg-slate-200" />}
            </div>
          ))}
        </div>

        <div className="px-6 py-5 overflow-y-auto flex-1">
          {currentStepLabel === "Type & Priority" && (
            <div className="space-y-5">
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Delivery Type</div>
                <div className="inline-flex rounded-lg border border-slate-200 p-1 bg-slate-50">
                  {["Direct", "Hub & Spoke"].map((opt) => (
                    <button key={opt} onClick={() => setDeliveryType(opt)} className={`px-4 py-1.5 text-sm rounded-md transition-colors ${deliveryType === opt ? "bg-white text-slate-800 shadow-sm border border-slate-200" : "text-slate-500"}`}>{opt}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Priority</div>
                <div className="flex gap-2">
                  {["High", "Medium", "Low"].map((opt) => (
                    <button key={opt} onClick={() => setPriority(opt)} className={`px-4 py-1.5 text-sm rounded-full border transition-colors ${priority === opt ? "text-white border-transparent" : "text-slate-500 border-slate-200 hover:bg-slate-50"}`} style={priority === opt ? { backgroundColor: ACCENT } : {}}>{opt}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Notes / Special Instructions</div>
                <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={4} className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 resize-none" />
              </div>
            </div>
          )}

          {currentStepLabel === "Select Fleet" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select Fleet</div>
              <div className="grid grid-cols-2 gap-3">
                {FLEET_STEP_OPTIONS.map((f) => (
                  <button key={f} onClick={() => setFleet(f)} className={`text-left border rounded-lg px-4 py-3 text-sm transition-colors ${fleet === f ? "border-blue-400 bg-blue-50 text-blue-700" : "border-slate-200 hover:bg-slate-50 text-slate-700"}`}>{f}</button>
                ))}
              </div>
            </div>
          )}

          {currentStepLabel === "Vehicle Type" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select Vehicle Type</div>
              <div className="grid grid-cols-2 gap-3">
                {VEHICLE_STEP_OPTIONS.map((v) => (
                  <button key={v.label} onClick={() => setVehicle(v.label)} className={`flex items-center gap-3 border rounded-lg px-4 py-3 text-sm transition-colors ${vehicle === v.label ? "border-blue-400 bg-blue-50 text-blue-700" : "border-slate-200 hover:bg-slate-50 text-slate-700"}`}>
                    <v.icon className="w-4 h-4" /> {v.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {currentStepLabel === "Select Partner" && (
                <div>
                  <div className="text-xs font-medium text-slate-500 mb-3">Select Partner / Driver</div>
                  <div className="grid grid-cols-2 gap-3">
                    {partners.map((p) => (
                      <button key={p._id} onClick={() => setPartner(p)} className={`text-left border rounded-lg px-4 py-3 transition-colors ${partner?._id === p._id ? "border-blue-400 bg-blue-50" : "border-slate-200 hover:bg-slate-50"}`}>
                        <div className="flex items-center gap-2 mb-1.5"><Truck className="w-3.5 h-3.5 text-slate-500" /><span className="text-sm font-medium text-slate-800">{p.name}</span></div>
                        <div className="text-xs text-slate-500 flex items-center gap-1.5 mb-0.5"><Phone className="w-3 h-3" /> {p.mobile}</div>
                        <div className="text-xs text-slate-400 font-mono">{p.vehicle_number}</div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
        </div>

        <div className="flex items-center justify-between px-6 py-4 border-t border-slate-200">
          <button onClick={() => (step === 1 ? onClose() : setStep(step - 1))} className="flex items-center gap-1 px-4 py-2 text-sm text-slate-600 rounded-lg border border-slate-200 hover:bg-slate-50"><ChevronLeft className="w-4 h-4" /> {step === 1 ? "Cancel" : "Back"}</button>
          <button 
                disabled={!canProceed} 
                onClick={() => {
                  if (step === allSteps.length) {
                    isAssign ? editTripAssignment() : createOrUpdateTrip();
                  } else {
                    setStep(step + 1);
                  }
                }} 
                className="flex items-center gap-1 px-5 py-2 text-sm font-medium text-white rounded-lg disabled:opacity-40" 
                style={{ backgroundColor: ACCENT }}
              >
                {step === allSteps.length ? (isAssign ? "Confirm Assignment" : "Create Trip") : "Next"}
                {step < allSteps.length && <ChevronRight className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </div>
  );
}*/

function TripWizard({ mode, partners, trip, onClose, onRefresh }) {
  const [step, setStep] = useState(1);
  const [deliveryType, setDeliveryType] = useState("Direct");
  const [priority, setPriority] = useState("Medium");
  const [notes, setNotes] = useState("");
  const [fleet, setFleet] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [partner, setPartner] = useState(trip?.partner_id || null);
  
  // State for Fare
  const [fare, setFare] = useState(trip?.total_value || "");

  // New states for 3PL integration
  const [thirdPartyApp, setThirdPartyApp] = useState(null);
  const [waNumber, setWaNumber] = useState("");

  const isAssign = mode === "assign";
  // Added "Enter Fare" to the end of the steps
  const allSteps = isAssign 
      ? ["Select Fleet", "Vehicle Type", "Select Partner", "Enter Fare"] 
      : ["Type & Priority", "Select Fleet", "Vehicle Type", "Select Partner", "Enter Fare"];
      
  const title = isAssign ? "Assign / Edit Fleet & Partner" : "Create Trip";
  const currentStepLabel = allSteps[step - 1];
  
  // Added validation for the new Fare step
  const canProceed = 
      (currentStepLabel === "Type & Priority") || 
      (currentStepLabel === "Select Fleet" && fleet) ||
      (currentStepLabel === "Vehicle Type" && vehicle) ||
      (currentStepLabel === "Select Partner" && (partner || thirdPartyApp)) ||
      (currentStepLabel === "Enter Fare" && fare !== "");

  // Extract pickup and dropoff data for the WhatsApp share feature
  const getTripExtents = () => {
    if (!trip || !trip.route_legs || trip.route_legs.length === 0) return { pickup: "Pending", dropoff: "Pending" };
    const firstLeg = trip.route_legs[0];
    const lastLeg = trip.route_legs[trip.route_legs.length - 1];
    const pickup = firstLeg.stops?.[0]?.location?.address || firstLeg.origin?.name || "Origin";
    const dropoff = lastLeg.stops?.[lastLeg.stops.length - 1]?.location?.address || lastLeg.destination?.name || "Destination";
    return { pickup, dropoff };
  };

  const { pickup, dropoff } = getTripExtents();
  const waText = `*New Trip Booking*\nTrip ID: ${trip?.trip_number || 'TBD'}\n\n*Pickup:* ${pickup}\n*Dropoff:* ${dropoff}\n\nDistance: ${trip?.totalDistance ? trip.totalDistance + ' km' : 0}`;

  const createOrUpdateTrip = async () => {
      try {
        const payload = {
          type: deliveryType,
          priority: priority,
          notes: notes,
          partner_id: partner?._id || undefined,
          status: partner ? "assigned" : (thirdPartyApp ? "3pl_assigned" : "draft"),
          platform: thirdPartyApp || "brickbucket",
          total_value: fare
        };

        if (mode === "assign" && trip?._id) {
          payload.trip_id = trip._id;
        }

        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/create-or-update-trip`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-token': decryptData(sessionStorage.getItem("token"))
          },
          body: JSON.stringify(payload)
        });
        
        const result = await response.json();
        if(result.success){
          if (onRefresh) onRefresh();
          onClose();
        }  
      } catch(err) {
        console.error(err);
      }
    };

  const editTripAssignment = async () => {
    try {
      const payload = {
        trip_id: trip._id,
        partner_id: partner?._id || undefined,
        platform: thirdPartyApp || undefined,
        total_value: fare
      };

      console.log(payload)

      const token = decryptData(sessionStorage.getItem("token"));
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/edit-trip-assignment`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-token': token || ""
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      if (result.success || response.ok) {
        if (onRefresh) onRefresh();
        onClose();
      } else {
        alert(result.message || "Failed to assign partner");
      }
    } catch (error) {
      console.error("Assignment error:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-xl border border-slate-200 max-h-[92vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-800">{title}</div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>

        <div className="flex items-center gap-2 px-6 pt-4">
          {allSteps.map((label, i) => (
            <div key={label} className="flex items-center gap-2 flex-1">
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-medium shrink-0" style={{ backgroundColor: step > i + 1 ? SUCCESS : step === i + 1 ? ACCENT : "#e2e8f0", color: step >= i + 1 ? "#fff" : "#64748b" }}>
                {step > i + 1 ? <Check className="w-3 h-3" /> : i + 1}
              </div>
              <span className={`text-xs ${step === i + 1 ? "text-slate-700 font-medium" : "text-slate-400"}`}>{label}</span>
              {i < allSteps.length - 1 && <div className="flex-1 h-px bg-slate-200" />}
            </div>
          ))}
        </div>

        <div className="px-6 py-5 overflow-y-auto flex-1">
          {currentStepLabel === "Type & Priority" && (
            <div className="space-y-5">
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Delivery Type</div>
                <div className="inline-flex rounded-lg border border-slate-200 p-1 bg-slate-50">
                  {["Direct", "Hub & Spoke"].map((opt) => (
                    <button key={opt} onClick={() => setDeliveryType(opt)} className={`px-4 py-1.5 text-sm rounded-md transition-colors ${deliveryType === opt ? "bg-white text-slate-800 shadow-sm border border-slate-200" : "text-slate-500"}`}>{opt}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Priority</div>
                <div className="flex gap-2">
                  {["High", "Medium", "Low"].map((opt) => (
                    <button key={opt} onClick={() => setPriority(opt)} className={`px-4 py-1.5 text-sm rounded-full border transition-colors ${priority === opt ? "text-white border-transparent" : "text-slate-500 border-slate-200 hover:bg-slate-50"}`} style={priority === opt ? { backgroundColor: ACCENT } : {}}>{opt}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="text-xs font-medium text-slate-500 mb-2">Notes / Special Instructions</div>
                <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={4} className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 resize-none" />
              </div>
            </div>
          )}

          {currentStepLabel === "Select Fleet" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select Fleet</div>
              <div className="grid grid-cols-2 gap-3">
                {FLEET_STEP_OPTIONS.map((f) => (
                  <button key={f} onClick={() => setFleet(f)} className={`text-left border rounded-lg px-4 py-3 text-sm transition-colors ${fleet === f ? "border-blue-400 bg-blue-50 text-blue-700 font-bold" : "border-slate-200 hover:bg-slate-50 text-slate-700"}`}>{f}</button>
                ))}
              </div>
            </div>
          )}

          {currentStepLabel === "Vehicle Type" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select Vehicle Type</div>
              <div className="grid grid-cols-2 gap-3">
                {VEHICLE_STEP_OPTIONS.map((v) => (
                  <button key={v.label} onClick={() => setVehicle(v.label)} className={`flex items-center gap-3 border rounded-lg px-4 py-3 text-sm transition-colors ${vehicle === v.label ? "border-blue-400 bg-blue-50 text-blue-700 font-bold" : "border-slate-200 hover:bg-slate-50 text-slate-700"}`}>
                    <v.icon className="w-4 h-4" /> {v.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {currentStepLabel === "Select Partner" && fleet !== "3 PL" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select Partner / Driver</div>
              <div className="grid grid-cols-2 gap-3">
                {partners.map((p) => (
                  <button key={p._id} onClick={() => setPartner(p)} className={`text-left border rounded-lg px-4 py-3 transition-colors ${partner?._id === p._id ? "border-blue-400 bg-blue-50" : "border-slate-200 hover:bg-slate-50"}`}>
                    <div className="flex items-center gap-2 mb-1.5"><Truck className="w-3.5 h-3.5 text-slate-500" /><span className="text-sm font-medium text-slate-800">{p.name}</span></div>
                    <div className="text-xs text-slate-500 flex items-center gap-1.5 mb-0.5"><Phone className="w-3 h-3" /> {p.mobile}</div>
                    <div className="text-xs text-slate-400 font-mono">{p.vehicle_number}</div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* New 3PL Booking & WhatsApp Interface */}
          {currentStepLabel === "Select Partner" && fleet === "3 PL" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Select 3PL Booking Platform</div>
              <div className="grid grid-cols-2 gap-3 mb-6">
                {["Ola", "Uber", "Rapido", "Porter", "Shadowfax", "Dunzo"].map((app) => (
                    <button key={app} onClick={() => setThirdPartyApp(app)} className={`text-left border rounded-lg px-4 py-3 transition-colors ${thirdPartyApp === app ? "border-blue-400 bg-blue-50 text-blue-700 font-bold" : "border-slate-200 hover:bg-slate-50 text-slate-700"}`}>
                        {app}
                    </button>
                ))}
              </div>
              
              <div className="border-t border-slate-200 pt-5">
                 <div className="text-xs font-medium text-slate-500 mb-2">Share Trip Data to Booking Agent / Driver via WhatsApp</div>
                 <div className="flex gap-2 mb-3">
                    <input 
                      type="text" 
                      placeholder="Enter mobile number" 
                      value={waNumber} 
                      onChange={(e) => setWaNumber(e.target.value)} 
                      className="flex-1 text-sm rounded-md border border-slate-300 px-3 py-2 outline-none focus:border-blue-400" 
                    />
                    <button 
                      onClick={() => window.open(`https://wa.me/${waNumber.replace(/\D/g,'')}?text=${encodeURIComponent(waText)}`, '_blank')} 
                      className="px-4 py-2 bg-[#25D366] text-white text-sm font-medium rounded-md hover:bg-[#20b958] transition-colors"
                    >
                      Share
                    </button>
                 </div>
                 <div className="bg-slate-50 border border-slate-200 rounded-md p-3 text-xs text-slate-600 whitespace-pre-wrap font-mono">
                    <span className="font-semibold block mb-1 text-slate-500 font-sans">Message Preview:</span>
                    {waText}
                 </div>
              </div>
            </div>
          )}

          {/* Fare Input Step */}
          {currentStepLabel === "Enter Fare" && (
            <div>
              <div className="text-xs font-medium text-slate-500 mb-3">Enter Trip Fare</div>
              <div>
                <input 
                  type="number" 
                  placeholder="Enter total fare value" 
                  value={fare} 
                  onChange={(e) => setFare(e.target.value)} 
                  className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400" 
                />
              </div>
            </div>
          )}

        </div>

        <div className="flex items-center justify-between px-6 py-4 border-t border-slate-200">
          <button onClick={() => (step === 1 ? onClose() : setStep(step - 1))} className="flex items-center gap-1 px-4 py-2 text-sm text-slate-600 rounded-lg border border-slate-200 hover:bg-slate-50"><ChevronLeft className="w-4 h-4" /> {step === 1 ? "Cancel" : "Back"}</button>
          <button 
                disabled={!canProceed} 
                onClick={() => {
                  if (step === allSteps.length) {
                    isAssign ? editTripAssignment() : createOrUpdateTrip();
                  } else {
                    setStep(step + 1);
                  }
                }} 
                className="flex items-center gap-1 px-5 py-2 text-sm font-medium text-white rounded-lg disabled:opacity-40" 
                style={{ backgroundColor: ACCENT }}
              >
                {step === allSteps.length ? (isAssign ? "Confirm Assignment" : "Create Trip") : "Next"}
                {step < allSteps.length && <ChevronRight className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Screen 4 — Fleet & Partners                                            */
/* ---------------------------------------------------------------------- */
/* function FleetScreen() {
  const [page, setPage] = useState(1);
  const pageSize = 5;
  const totalPages = Math.ceil(PARTNERS.length / pageSize);
  const pagePartners = PARTNERS.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div>
      <div className="text-sm font-medium text-slate-700 mb-3">Delivery Fleets & 3PL</div>
      <div className="grid grid-cols-2 gap-4 mb-8">
        {FLEETS.map((f) => (
          <div key={f.name} className="border border-slate-200 rounded-xl p-5 bg-white flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold text-slate-800">{f.name}</div>
              <div className="text-xs text-slate-400 mb-3">{f.subtitle}</div>
              <div className="flex items-center gap-4 text-xs text-slate-500">
                <span>{f.vehicles} vehicles</span>
                <span>{f.drivers} drivers</span>
              </div>
            </div>
            <div className="w-11 h-11 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: ACCENT_SOFT }}>
              <f.icon className="w-5 h-5" style={{ color: ACCENT }} />
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-medium text-slate-700">Registered Partners & Drivers</div>
      </div>
      <div className="flex items-center gap-2 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Search by name, phone, or vehicle..."
            className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-slate-200 bg-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400"
          />
        </div>
        <div className="flex-1" />
        <button
          className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white rounded-lg"
          style={{ backgroundColor: ACCENT }}
        >
          <Plus className="w-4 h-4" /> Add Partner
        </button>
      </div>

      <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
        {pagePartners.map((p, i) => (
          <div
            key={p.name}
            className={`flex items-center gap-4 px-4 py-3.5 ${i !== pagePartners.length - 1 ? "border-b border-slate-100" : ""}`}
          >
            <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
              <User className="w-4 h-4 text-slate-500" />
            </div>
            <div className="w-40 shrink-0">
              <div className="text-sm font-medium text-slate-800">{p.name}</div>
            </div>
            <Pill tone="blue">{p.vehicleType}</Pill>
            <Pill tone="slate">{p.fleetType}</Pill>
            <div className="flex items-center gap-1.5 text-xs text-slate-500 w-36 shrink-0">
              <Phone className="w-3 h-3" /> {p.phone}
            </div>
            <div className="text-xs font-mono text-slate-500 w-28 shrink-0">{p.reg}</div>
            <div className="text-xs text-slate-400 flex-1 truncate">{p.email}</div>
            <button className="p-1.5 rounded-md hover:bg-slate-100 shrink-0">
              <Edit2 className="w-3.5 h-3.5 text-slate-400" />
            </button>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-4">
        <div className="text-xs text-slate-400">
          Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, PARTNERS.length)} of {PARTNERS.length}
        </div>
        <div className="flex items-center gap-1">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="p-1.5 rounded-md border border-slate-200 disabled:opacity-40 hover:bg-slate-50"
          >
            <ChevronLeft className="w-3.5 h-3.5 text-slate-500" />
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              onClick={() => setPage(n)}
              className={`w-7 h-7 text-xs rounded-md ${n === page ? "text-white" : "text-slate-500 hover:bg-slate-50 border border-slate-200"}`}
              style={n === page ? { backgroundColor: ACCENT } : {}}
            >
              {n}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
            className="p-1.5 rounded-md border border-slate-200 disabled:opacity-40 hover:bg-slate-50"
          >
            <ChevronRight className="w-3.5 h-3.5 text-slate-500" />
          </button>
        </div>
      </div>
    </div>
  );
} */

function FleetScreen({ fleets = [], partners = [], vehicles = [], onRefresh }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFleet, setSelectedFleet] = useState(null);
  
  // Modal, Edit & Popup State
  const [showAddPartnerPopup, setShowAddPartnerPopup] = useState(false);
  const [editingPartnerId, setEditingPartnerId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popup, setPopup] = useState({ show: false, message: "", type: "success" });
  
  const [partnerForm, setPartnerForm] = useState({
    name: "",
    mobile: "",
    email: "",
    vehicle_number: "",
    vehicle_type: "",
    platform: "brickbucket",
    fleet: "brickbucket"
  });

  // Filter partners by Search and Selected Fleet
  const filteredPartners = partners.filter((p) => {
    const searchLower = searchQuery.toLowerCase();
    const matchesSearch = 
      p.name?.toLowerCase().includes(searchLower) ||
      p.mobile?.includes(searchQuery) ||
      p.vehicle_number?.toLowerCase().includes(searchLower) ||
      p.email?.toLowerCase().includes(searchLower);
    
    const partnerFleet = p.fleet || p.type || "Brickbucket"; 
    const matchesFleet = selectedFleet ? partnerFleet.toLowerCase() === selectedFleet.toLowerCase() : true;
    
    return matchesSearch && matchesFleet;
  });

  // Pagination hook (5 per page)
  const {
    currentItems: paginatedPartners,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    handlePreviousPage,
    handleNextPage,
  } = usePagination(filteredPartners, 3);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    handlePageChange(1);
  };

  const toggleFleetFilter = (fleet) => {
    setSelectedFleet(prev => (prev === fleet ? null : fleet));
    handlePageChange(1);
  };

  const resetForm = () => {
    setPartnerForm({ name: "", mobile: "", email: "", vehicle_number: "", vehicle_type: "", platform: "brickbucket", fleet: "brickbucket" });
    setEditingPartnerId(null);
  };

  const handleEditClick = (partner) => {
    setPartnerForm({
      name: partner.name || "",
      mobile: partner.mobile || "",
      email: partner.email || "",
      vehicle_number: partner.vehicle_number || "",
      vehicle_type: partner.vehicle_type || "",
      platform: partner.platform || "brickbucket",
      fleet: partner.fleet || "brickbucket"
    });
    setEditingPartnerId(partner._id || partner.id);
    setShowAddPartnerPopup(true);
  };

  // API Submission for Create & Update
  const handleSavePartner = async () => {
    try {
      setIsSubmitting(true);
      if (!partnerForm.name || !partnerForm.mobile || !partnerForm.vehicle_number || !partnerForm.vehicle_type) {
        setPopup({ show: true, message: "Please fill all required fields", type: "error" });
        return;
      }

      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);
      const encryptedhubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedhubId);

      const payload = {
        ...partnerForm,
        hubId: hubId,
        roleId: 15,
      };

      if (editingPartnerId) {
        payload.partner_id = editingPartnerId; 
      }

      const endpoint = editingPartnerId 
        ? "update-delivery-partner" 
        : "create-delivery-partner";

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/${endpoint}`, {
        method: editingPartnerId ? "PUT" : "POST", 
        headers: { "Content-Type": "application/json", "x-token": token || "" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.success || response.ok) {
        setPopup({ show: true, message: `Delivery partner ${editingPartnerId ? "updated" : "created"} successfully!`, type: "success" });
        setShowAddPartnerPopup(false);
        resetForm();
        if (onRefresh) onRefresh();
      } else {
        setPopup({ show: true, message: result.message || "Failed to save partner", type: "error" });
      }
    } catch (error) {
      setPopup({ show: true, message: "Network error. Please try again.", type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getVehicleIcon = (type) => {
    if (!type) return "🚗";
    const key = type.toLowerCase();
    return vehicleTypeIcon[key] || "🚗";
  };

  return (
    <div className="space-y-6 relative">
      {/* ── Custom Status Popup Overlay ── */}
      {popup.show && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm w-full text-center animate-in zoom-in duration-200">
            {popup.type === 'success' ? (
              <CheckCircle className="w-14 h-14 text-green-500 mx-auto mb-4" />
            ) : (
              <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
            )}
            <h3 className="font-bold text-xl text-gray-900 mb-2">
              {popup.type === 'success' ? 'Success!' : 'Error'}
            </h3>
            <p className="text-gray-600 text-sm mb-6">{popup.message}</p>
            <Button 
              className={`w-full ${popup.type === 'success' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'} text-white`} 
              onClick={() => setPopup({ show: false, message: "", type: "success" })}
            >
              Close
            </Button>
          </div>
        </div>
      )}

{/* ── Fleet Categories ── */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-medium">Delivery Fleets & 3PL</h4>
        </div>
        {(!fleets || fleets.length === 0)?(
          <div className="flex flex-col items-center justify-center py-10 text-sm text-gray-500 border rounded-lg">
            <Truck className="w-8 h-8 mb-2 text-gray-400" />
            <p className="font-medium">No fleets found.</p>
          </div>
        ):(
        <div className="grid grid-cols-2 gap-3">
          {fleets.map((f) => {
            const isSelected = selectedFleet === f;
            
            // Restore the dynamic icon and color mapping
            const typeCfg = partnerTypeConfig[f] || { label: f, color: "bg-gray-100 text-gray-700", icon: Truck };
            const TypeIcon = typeCfg.icon;

            return (
              <Card 
                key={f} 
                className={`p-4 cursor-pointer transition-all ${isSelected ? "ring-2 ring-blue-500 bg-blue-50/20" : "hover:border-gray-300"}`}
                onClick={() => toggleFleetFilter(f)}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg ${typeCfg.color.replace("text-", "bg-").replace("-700", "-100")}`}>
                      <TypeIcon className={`w-4 h-4 ${typeCfg.color.split(" ")[1]}`} />
                    </div>
                    <div>
                      <p className={`font-medium text-sm ${isSelected ? "text-blue-700" : ""}`}>{f}</p>
                      {/* Restored the dynamic label badge */}
                      <span className={`text-xs px-1.5 py-0.5 rounded-full ${typeCfg.color}`}>
                        {typeCfg.label}
                      </span>
                    </div>
                  </div>
                  {isSelected && <CheckCircle className="w-4 h-4 text-blue-500" />}
                </div>
              </Card>
            );
          })}
        </div>
        )}
      </div>

      {/* ── Partners List & Search ── */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-medium">Registered Partners & Drivers</h4>
          <Button size="sm" onClick={() => { resetForm(); setShowAddPartnerPopup(true); }} className="bg-[#f7525a] text-white hover:bg-[#f7525a]">
            <Plus className="w-4 h-4 mr-1" /> Add Partner
          </Button>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <div className="relative flex-1 max-w-sm">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input 
              className="pl-9 bg-white" 
              placeholder="Search by name, phone, or vehicle..." 
              value={searchQuery} 
              onChange={handleSearchChange} 
            />
          </div>
          {selectedFleet && (
            <Badge variant="secondary" className="flex items-center gap-1 bg-blue-100 text-blue-700 hover:bg-blue-200 cursor-pointer" onClick={() => toggleFleetFilter(selectedFleet)}>
              Filtered by: {selectedFleet} <X className="w-3 h-3 ml-1" />
            </Badge>
          )}
        </div>

        <div className="space-y-2 ">
          {paginatedPartners.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10 text-sm text-gray-500 border rounded-lg">
              <Users className="w-8 h-8 mb-2 text-gray-400" />
              <p className="font-medium">No delivery partners found.</p>
            </div>
          ) : (
            paginatedPartners.map((p) => (
              <div key={p._id || p.id} className="flex items-center justify-between gap-4 p-3 border rounded-lg bg-card hover:bg-accent/30 transition-colors">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm">{p.name}</span>
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-mono uppercase flex items-center gap-1">
                      {getVehicleIcon(p.vehicle_type)} {p.vehicle_type || "Vehicle"}
                    </span>
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 border">
                      {p.platform || p.fleet || "Internal"}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1"><Phone className="w-3 h-3"/> {p.mobile}</span>
                    <span>·</span>
                    <span className="flex items-center gap-1 font-mono">{p.vehicle_number || "N/A"}</span>
                    {p.email && (
                      <>
                        <span>·</span>
                        <span className="flex items-center gap-1">✉️ {p.email}</span>
                      </>
                    )}
                  </div>
                </div>
                
                {/* Edit Button */}
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={() => handleEditClick(p)} 
                  className="flex-shrink-0 text-gray-500 hover:text-blue-600 hover:bg-blue-50"
                >
                  <Edit className="w-4 h-4" />
                </Button>
              </div>
            ))
          )}
        </div>

        {totalPages > 1 && (
          <div className="mt-4 border-t pt-4">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              itemsPerPage={3}
              onPageChange={handlePageChange}
              onPreviousPage={handlePreviousPage}
              onNextPage={handleNextPage}
              showInfo={true}
              itemName="Partners"
            />
          </div>
        )}
      </div>

      {/* ── Add / Edit Partner Modal ── */}
      {showAddPartnerPopup && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[990] p-4">
          <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="px-5 py-4 border-b flex justify-between items-center bg-gray-50">
              <div>
                <h3 className="font-bold text-gray-800">{editingPartnerId ? "Edit Delivery Partner" : "Add Delivery Partner"}</h3>
                <p className="text-xs text-gray-500">{editingPartnerId ? "Update driver details" : "Register a new fleet driver"}</p>
              </div>
              <button onClick={() => { setShowAddPartnerPopup(false); resetForm(); }} className="p-1.5 hover:bg-gray-200 rounded-md transition-colors text-gray-500">
                <X className="w-5 h-5" />
              </button>
            </div>
      
            <div className="p-5 overflow-y-auto space-y-4 text-sm">
              <div className="space-y-3">
                <div>
                  <label className="font-medium text-gray-700 block mb-1 text-xs">Full Name *</label>
                  <Input placeholder="Enter driver name" value={partnerForm.name} onChange={(e) => setPartnerForm({ ...partnerForm, name: e.target.value })} />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Mobile Number *</label>
                    <Input placeholder="10-digit mobile" maxLength={10} value={partnerForm.mobile} onChange={(e) => setPartnerForm({ ...partnerForm, mobile: e.target.value.replace(/\D/g, '') })} />
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Email Address</label>
                    <Input type="email" placeholder="Email" value={partnerForm.email} onChange={(e) => setPartnerForm({ ...partnerForm, email: e.target.value })} />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 border-t pt-3">
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Vehicle Type *</label>
                    <select 
                      className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-blue-500 bg-white" 
                      value={partnerForm.vehicle_type} 
                      onChange={(e) => setPartnerForm({ ...partnerForm, vehicle_type: e.target.value })}
                    >
                      <option value="">Select Vehicle Type</option>
                      {vehicles.map((vType, idx) => {
                        const value = typeof vType === 'string' ? vType : (vType.name || vType.type || "");
                        return (
                          <option key={idx} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Vehicle Number *</label>
                    <Input placeholder="e.g. MH 01 AB 1234" value={partnerForm.vehicle_number} onChange={(e) => setPartnerForm({ ...partnerForm, vehicle_number: e.target.value.toUpperCase() })} />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Fleet *</label>
                    <select className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-blue-500 bg-white" value={partnerForm.fleet} onChange={(e) => setPartnerForm({ ...partnerForm, fleet: e.target.value })}>
                      <option value="brickbucket">Brickbucket</option>
                      <option value="on demand">On Demand</option>
                      <option value="supplier">Supplier</option>
                      <option value="3 pl">3 PL</option>
                    </select>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 block mb-1 text-xs">Platform *</label>
                    <select className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-blue-500 bg-white" value={partnerForm.platform} onChange={(e) => setPartnerForm({ ...partnerForm, platform: e.target.value })}>
                      <option value="brickbucket">Brickbucket</option>
                      <option value="own">Own</option>
                      <option value="ola">Ola</option>
                      <option value="uber">Uber</option>
                      <option value="rapido">Rapido</option>
                      <option value="shadowfax">Shadowfax</option>
                      <option value="porter">Porter</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
      
            <div className="px-5 py-3 border-t bg-gray-50 flex justify-end gap-3 flex-shrink-0">
              <Button variant="outline" onClick={() => { setShowAddPartnerPopup(false); resetForm(); }}>Cancel</Button>
              <Button onClick={handleSavePartner} disabled={isSubmitting} className="bg-[#f7525a] text-white hover:bg-[#f7525a] min-w-[120px]">
                {isSubmitting ? 'Saving...' : (editingPartnerId ? 'Update Partner' : 'Save Partner')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ContactModal({ phone, onClose }) {
  if (!phone) return null;
  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-2xl p-5 flex flex-col min-w-[280px] animate-in zoom-in duration-200">
        <div className="flex items-center justify-between mb-4 border-b border-slate-100 pb-3">
          <h4 className="font-bold text-slate-800 text-sm">Contact Actions</h4>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-slate-100"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        <div className="text-center mb-5">
          <div className="text-lg font-semibold text-blue-600 tracking-wide">{phone}</div>
        </div>
        <div className="flex flex-col gap-2.5">
          <button onClick={() => { navigator.clipboard.writeText(phone); onClose(); }} className="px-4 py-2.5 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-lg text-sm text-slate-700 font-medium text-center transition-colors">
            Copy Number
          </button>
          <a href={`https://wa.me/${phone.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" onClick={onClose} className="px-4 py-2.5 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/20 rounded-lg text-sm text-[#1da850] font-bold text-center transition-colors">
            Message on WhatsApp
          </a>
          <a href={`tel:${phone}`} onClick={onClose} className="px-4 py-2.5 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg text-sm text-blue-700 font-medium text-center transition-colors">
            Call Number
          </a>
        </div>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Root App                                                               */
/* ---------------------------------------------------------------------- */
export default function DeliveryManagementDashboard() {
  const [activeTab, setActiveTab] = useState("orders");

  const [orders,setOrders] = useState();
  const [shipments,setShipments] = useState();
  
  // Track state
  const [trackOrder, setTrackOrder] = useState(null);
  const [trackDg, setTrackDg] = useState(null);
  const [trackShipment, setTrackShipment] = useState(null);
  const [trackTrip, setTrackTrip] = useState(null);
  const [wizard, setWizard] = useState(null);

  const [contactPhone, setContactPhone] = useState(null);
  
  // Trips view state
  const [viewTripShipments, setViewTripShipments] = useState(null);
  const [viewTripLegs, setViewTripLegs] = useState(null);

  // Custom Trip Creation Flow from Shipments Screen
  const [createTripShipmentIds, setCreateTripShipmentIds] = useState(null);
  const [trips,setTrips] = useState();

  //Fleet Screen States
  const [fleets,setFleets] = useState([]);
  const [partners,setPartners] = useState([]);
  const [vehicles,setVehicles] = useState([]);

  const token = decryptData(sessionStorage.getItem("token"));

  useEffect(() => {
    window.handleGlobalPhoneClick = (phone) => setContactPhone(phone);
    return () => delete window.handleGlobalPhoneClick;
  }, []);

  // MASTER REFRESH FUNCTION
  const refreshDashboard = () => {
    fetchTrips();
    fetchPartners();
    fetchOrderToCreateShipments();
    fetchShipments();
  };

  useEffect(() => {
    refreshDashboard();
  }, []);

  // Fetch Trips
  const fetchTrips = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/trips`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token || "",
          },
        }
      );

      const data = await response.json();

      if (data.success) {
        setTrips(data.data || []);
      } else {
        setTrips(TRIPS);
      }
    } catch (error) {
      console.error("Error fetching trips:", error);
    }
  };

  // Fetch Delivery Partners
  const fetchPartners = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/get-all-delivery-partners`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token || "",
          },
        }
      );

      const data = await response.json();

      if (data.success) {
        setPartners(data.data?.partners || []);
        setFleets(data.data?.fleets || []);
        setVehicles(data.data?.vehicle_types || []);
      } else {
        console.error("Failed to fetch partners:", data);
      }
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  };

  const fetchOrderToCreateShipments = async () => {
    try{
        const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/get-orders-to-create-shipments`,
        {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "x-token": token || "",
        },
        }
    );

    const data = await response.json();

    if (data.success) {
        setOrders(data.data || []);
    } else {
        setOrders(ORDERS);
    }
    }catch(error){
      console.error("Error fetching Orders:", error);
    }
  };
  
  const fetchShipments = async () => {
    try{
            const response = await fetch(
          `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery/shipments`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-token": token || "",
            },
          }
        );
  
        const data = await response.json();
  
        if (data.success) {
          setShipments(data.data || []);
        } else {
          setShipments(SHIPMENTS);
        }
    }catch(error){
        console.error("Error fetching Shipments:", error);
    }
  };

  return (
    <div className="min-h-screen" style={{ fontFamily: "'IBM Plex Sans', ui-sans-serif, system-ui" }}>
      <div className="max-w-full border rounded mx-auto px-6 py-4">
        <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        >
        <div className="flex flex-row justify-between mr-10">
        <TabsList>
        {TABS.map((t) => {
            const Icon = t.icon;

            return (
            <TabsTrigger
                key={t.key}
                value={t.key}
                className="rounded-md px-4 data-[state=active]:bg-gray-200 data-[state=active]:text-black data-[state=active]:shadow-sm"
            >
                {Icon && <Icon className="w-4 h-4 mr-1.5" />}
                {t.label}
            </TabsTrigger>
            );
        })}
        </TabsList>
        </div>
        {/* Pass onRefresh to tabs that need it */}
        {activeTab === "orders" && <OrdersScreen orders={orders} onTrackOrder={setTrackOrder} onTrackDg={(dg, order) => setTrackDg({ dg, orderInfo: order })} onRefresh={refreshDashboard} />}
        {activeTab === "shipments" && <ShipmentsScreen shipments={shipments} onTrack={setTrackShipment} onCreateTrip={(ids) => setCreateTripShipmentIds(ids)} />}
        {activeTab === "trips" && <TripsScreen trips={trips} onTrack={setTrackTrip} onAssign={(selectedTrip) => setWizard({ mode: "assign", trip: selectedTrip })} onViewShipments={setViewTripShipments} onViewRouteLegs={setViewTripLegs} onPhoneClick={setContactPhone} />}
        {activeTab === "fleet" && <FleetScreen fleets={fleets} partners={partners} vehicles={vehicles} onRefresh={refreshDashboard} />}
        </Tabs>  
      </div>

      {/* Render Popups/Modals based on active tracking object */}
      <OrderTrackPanel order={trackOrder} onClose={() => setTrackOrder(null)} />
      <DgTrackPanel dg={trackDg?.dg} orderInfo={trackDg?.orderInfo} onClose={() => setTrackDg(null)} />
      <ShipmentTrackPanel shipment={trackShipment} onClose={() => setTrackShipment(null)} />
      
      <TripTrackModal trip={trackTrip} onClose={() => setTrackTrip(null)} />
      <TripShipmentsModal trip={viewTripShipments} onClose={() => setViewTripShipments(null)} />
      <TripRouteLegsModal trip={viewTripLegs} onClose={() => setViewTripLegs(null)} />
      
      {/* Pass onRefresh to Modals */}
      {createTripShipmentIds && <CreateTripModal shipmentsData={shipments} selectedShipmentIds={createTripShipmentIds} onClose={() => setCreateTripShipmentIds(null)} onRefresh={refreshDashboard} />}
      {wizard && <TripWizard mode={wizard.mode} partners={partners} trip={wizard.trip} onClose={() => setWizard(null)} onRefresh={refreshDashboard} />}
      <ContactModal phone={contactPhone} onClose={() => setContactPhone(null)} />
    </div>
  );
}